  // Mostrar PDF en nueva pestaña y permitir descarga

import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { VehiclesService } from "../../../../../../shared/services/vehicles.service";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import {
  NgbAccordion,
  NgbModal,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbdSortableHeader } from "../../../../../../shared/directives/NgbdSortableHeader";
import { ActivatedRoute, Router } from "@angular/router";
import { ConductorVehiculoService } from "../../../../../../shared/services/conductor.service";
import { EmpresasService } from "../../../../../../shared/services/empresas.service";
import { UsuarioContratistaService } from "../../../../../../shared/services/usuario-contratista.service";
import { UsuarioObjetosContratosService } from "../../../../../../shared/services/usuario-objetos-contratos.service";
import { ObjetosContratosService } from "../../../../../../shared/services/objetos_contratos.service";
import {
  Contrato,
  ContratosService,
} from "../../../../../../shared/services/contrato.service";
import { RutasService } from "../../../../../../shared/services/ruta.service";
import { DataService } from "../../../../../../shared/services/municipios.service";
import { PlanillaService } from "../../../../../../shared/services/planillas.service";
import { TipoViajeService } from "../../../../../../shared/services/tipo_viaje.service";
import { AdministracionService } from "../../../../../../shared/services/administracion.services";
import { Console } from "node:console";
import { Administracion } from "../../../../../../shared/model/administracion.model";
import jsPDF from "jspdf";
import { AuthService } from "../../../../../../shared/services/auth.service";
import * as QRCode from 'qrcode';
import { gpcGoogleService } from "../../../../../../shared/services/gpcGoogle.service";
import { min, forkJoin, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { env } from "node:process";
import { environment } from "../../../../../../../environments/environment";
import { autoTable } from "jspdf-autotable";
import { ExtractoPasajero } from "../../../../../../shared/model/ExtractoPasajero.model";
import { ListadoPasajerosComponent } from "../../../../listado-pasajeros/listado-pasajeros.component";
import { ExtractoPasajerosService } from "../../../../../../shared/services/extracto-pasajeros.service";
import { AdminSeafLoadingService } from "../../../../../../shared/services/adminseaf-loading.service";

declare var require: any;
const Swal = require("sweetalert2");

export function noEspaciosValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value || "";
  return value.trim().length === 0 ? { noEspacios: true } : null;
}

@Component({
  selector: "app-crear-extracto",
  templateUrl: "./crear-extracto.component.html",
  styleUrls: ["./crear-extracto.component.scss"],
})
export class CrearExtractoComponent {
  @ViewChild("inputIdres") inputIdres!: ElementRef<HTMLInputElement>;
  @ViewChild("inputResponsable")
  inputResponsable!: ElementRef<HTMLInputElement>;
  @ViewChild("inputDiResponsable")
  inputDiResponsable!: ElementRef<HTMLInputElement>;
  @ViewChild("inputContrato")
  inputContrato!: ElementRef<HTMLInputElement>;
  @ViewChild("inputCuires") inputCuires!: ElementRef<HTMLInputElement>;
  @ViewChild("inputTelefono") inputTelefono!: ElementRef<HTMLInputElement>;
  @ViewChild("inputMailResponsable") inputMailResponsable!: ElementRef;
  @ViewChild("inputEmpresa") inputEmpresa!: ElementRef;
  @ViewChild("inputNit") inputNit!: ElementRef;
  @ViewChild("inputNombre") inputNombre!: ElementRef;
  @ViewChild("inputCodigo") inputCodigo!: ElementRef;
  @ViewChild("inputDireccion") inputDireccion!: ElementRef;
  @ViewChild("inputCiudad") inputCiudad!: ElementRef;
  @ViewChild("inputCelular") inputCelular!: ElementRef;
  @ViewChild("inputEmail") inputEmail!: ElementRef;
  @ViewChild("inputTipo") inputTipo!: ElementRef;
  @ViewChild("inputInicio") inputInicio!: ElementRef;
  @ViewChild("inputFin") inputFin!: ElementRef;
  @ViewChild("inputPasajeros") inputPasajeros!: ElementRef;
  @ViewChild("inputValor") inputValor!: ElementRef;
  @ViewChild("inputInicial") inputInicial!: ElementRef;
  @ViewChild("inputFinal") inputFinal!: ElementRef;
  @ViewChild("inputObjeto") inputObjeto!: ElementRef;
  @ViewChild("inputTipoViaje") inputTipoViaje!: ElementRef;
  @ViewChild("inputOrigen") inputOrigen!: ElementRef;
  @ViewChild("inputDestino") inputDestino!: ElementRef;
  @ViewChild("inputOrigenCont") inputOrigenCont!: ElementRef;
  @ViewChild("inputDestinoCont") inputDestinoCont!: ElementRef;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;

  activePanel: string[] = ["static-1"]; // El panel se abre por defecto
  validate: boolean = false;
  vehicles: any[] = [];
  formNuevo!: FormGroup;
  pageSize1: number = 5;
  page1: number = 1;
  totalItems!: number;;
  editarSeleccion: any;
  placaSeleccionada: any;
  editMode!: boolean;
  formEmpresa!: FormGroup;
  vehiculoSeleccionado: any;
  vehiclesFullList: any[] = []; // Guardar la lista completa de vehículos
  conductores: any[] = [];
  respuestaVehiculos: any;
  vehicle: any;  
  conductorSeleccionado: any = null; // guarda el conductor elegido
  mostrarTabla: boolean = false;
  conductoresAgregados: any[] = []; // Lista de los que se agregan a la tabla
  empresas: any[] = [];
  empresaMostrada: any = null;
  empresaselecionada: any;
  modalEmpresaRef!: NgbModalRef;
  formContrato!: FormGroup;
  modalContratoRef!: NgbModalRef;
  contratoSeleccionado: any;
  empresaSeleccionada: string | null = null;
  contratoMostrado: Contrato | null = null;
  isContratos: boolean = false;
  isResponsable: boolean = false;
  isDisponilidad: boolean = false;
  loadingContratista: boolean = false;
  opcionSeleccionada: string | null = null;
  contratoBuscado: boolean = false; // nuevo flag para saber si ya se hizo una búsqueda
  contratosMostrados: Contrato[] = [];
  objetos: any;
  formPlanilla!: FormGroup;
  maxDate!: string;
  minDate!: string;
  Rutas: any;
  municipios!: any[];
  disponibilidadActiva: boolean = false;
  isEnableFuec: boolean = true;
  modelo: string = "";
  marca: string = "";
  tipos: string = "";
  interno: string = "";
  numero_tarjeta: string = "";
  placa: string | null = null;
  fechaMaxima: string | null = null;
  fechaMaximaSalida: string | null = null;
  fechaMinimaSalida: string | null = null;
  numeroContratos: Contrato[] = [];
  tipoviaje: any[] = [];
  rutaForm!: FormGroup;
  rutaSeleccionada: any;
  origenSeleccionado: string = "";
  destinoSeleccionado: string = "";
  nombreRuta: string = "";
  public fechacobeps: string = "";
  visibleConductores: boolean[] = [true, false, false]; // Muestra el primero por defecto
  activePanelmodel: string[] = ["static-1"];
  extracto!: any;
  fechaMinimaFinal: string = ""; // Para el campo 'fin'
  objetoDeshabilitado = false;
  empresa: { nit: string; nombre: string } | null = null;
  datosResp: any;
  fechaHoy: string = this.formatDateForInput(new Date());
  fechaMinimaRegreso: string = this.fechaHoy; // Inicialmente igual al día de hoy
  administraciones: Administracion[] = [];
  codigoUnificado:any;
  conductoresSeleccionados: any[] = [];
  responsableSeleccionados: Contrato[] = [];
  pasajeros: ExtractoPasajero[] = [];
  cedula: any;
  conductor: any;
  licencia: any; 
  vigencia: any;

 cedula1: any;
 conductor1: any;
 licencia1: any;
 vigencia1: any;

 cedula2: any; 
 conductor2: any;
 licencia2: any;
 vigencia2: any;
 convenio!: number;

 idReponsable:any;
 nombreResponsable:any;
 telefonoResponsable:any;
 direccionResponsable:any;
 usuarioLogin: any | null = null;
 esUsuarioTenant: boolean = false;
mostrarOrigenDestino: boolean = false;
private mostrarAvisoDisponibilidad: boolean = true;
 altura: number = 0;
  ancho: number = 0;
  posicionX: number = 0;
  posicionY: number = 0;
  constructor(
    private objetoscontratosService: ObjetosContratosService,
    private rutasService: RutasService,
    private contratoService: ContratosService,
    private empresasService: EmpresasService,
    private usuarioContratistaService: UsuarioContratistaService,
    private usuarioObjetosContratosService: UsuarioObjetosContratosService,
    private vehicleService: VehiclesService,
    private conductorService: ConductorVehiculoService,
    private planillaService: PlanillaService,
    private administracionesServices: AdministracionService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private dataService: DataService,
    private tipoViajeService: TipoViajeService,
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private gpcGoogle: gpcGoogleService,
    private pasajerosService: ExtractoPasajerosService,
    private loadingService: AdminSeafLoadingService 
  ) { }

  ngOnInit(): void {

  this.usuarioLogin = this.authService.getCurrentUserValue();
 // console.log('🔍 Usuario Login completo:', this.usuarioLogin);
  
  // Validar si el usuario es tenant
  if (this.usuarioLogin?.roles) {
    this.esUsuarioTenant =  this.usuarioLogin.roles.includes('USUARIO_TENANT');
  //  this.esUsuarioTenant=false;
   // console.log('Es usuario tenant:', this.esUsuarioTenant);
  }

    this.setMinAndMaxDates();
    this.inicializarFormularios();
    this.cargarParametrosIniciales();
    this.escucharCambiosFormulario();
    // 👉 Aquí agregas los observadores de cambio para validar las fechas
    this.formPlanilla.get('finicial')?.valueChanges.subscribe(() => {
      this.formPlanilla.updateValueAndValidity();
    });

    this.formPlanilla.get('ffinal')?.valueChanges.subscribe(() => {
      this.formPlanilla.updateValueAndValidity();
    });
  }

  private escucharCambiosFormulario(): void {
    this.formPlanilla.get('finicial')?.valueChanges.subscribe((fechaInicial: string) => {
      this.actualizarMinFechaRegreso(fechaInicial);
    });

    this.formContrato.get("inicio")?.valueChanges.subscribe(() => {
      this.actualizarMinFechaFinal();
    });

    this.formContrato.get('tipo')?.valueChanges.subscribe((valorSeleccionado) => {
      const disponibilidadControl = this.formContrato.get('disponibilidad');
      this.mostrarAvisoDisponibilidad = true;

      if (valorSeleccionado === 2 || valorSeleccionado === 5) {
        disponibilidadControl?.enable();
        if (disponibilidadControl?.value === null || disponibilidadControl?.value === undefined) {
          disponibilidadControl?.setValue(0, { emitEvent: false });
        }
      } else {
        disponibilidadControl?.setValue(0, { emitEvent: false });
        disponibilidadControl?.disable();
      }

      this.onDisponibilidadChange(disponibilidadControl?.value ?? 0);
    });

    this.formContrato.get('disponibilidad')?.valueChanges.subscribe((valor) => {
      this.onDisponibilidadChange(valor);
    });


  }
private cargarParametrosIniciales(): void {
  // 1. Obtener valores de la ruta e historial
  this.placa = this.route.snapshot.paramMap.get("placa");
  this.fechaMaximaSalida = history.state.fechaMaxima || null;

  // 2. Cargar información base del vehículo
  this.cargarPlacaDesdeRuta();
  
  // 3. Cargar datos en paralelo para optimizar tiempo de carga
  forkJoin({
    administracion: this.administracionesServices.obtenerTodas().pipe(
      catchError(error => {
        console.error("Error al cargar administración:", error);
        return of([]);
      })
    ),
    empresas: this.esUsuarioTenant
      ? this.usuarioContratistaService.getContratistaPorUsuario(this.usuarioLogin?.id).pipe(
          catchError(error => {
            console.error("Error al cargar empresas (tenant):", error);
            return of([]);
          })
        )
      : this.empresasService.getContratistas().pipe(
          catchError(error => {
            console.error("Error al cargar empresas:", error);
            return of([]);
          })
        ),
    municipios: this.dataService.getDatos().pipe(
      catchError(error => {
        console.error("Error al cargar municipios:", error);
        return of([]);
      })
    ),
    rutas: this.rutasService.getRutas().pipe(
      catchError(error => {
        console.error("Error al cargar rutas:", error);
        return of([]);
      })
    ),
    tipoViaje: this.tipoViajeService.getAll().pipe(
      catchError(error => {
        console.error("Error al cargar tipos de viaje:", error);
        return of([]);
      })
    ),
    objetos: this.objetoscontratosService.getObjetos().pipe(
      catchError(error => {
        console.error("Error al cargar objetos:", error);
        return of([]);
      })
    )
  }).pipe(
    finalize(() => {
      // Operaciones finales después de cargar todos los catálogos
      this.actualizarMinFechaFinal();
    })
  ).subscribe({
    next: ({ administracion, empresas, municipios, rutas, tipoViaje, objetos }) => {
      // Asignar datos de administración
      if (administracion && administracion.length > 0) {
        this.administraciones = administracion;
        this.altura = administracion[0].dimensionLogo.h;
        this.ancho = administracion[0].dimensionLogo.w;
        this.posicionX = administracion[0].dimensionLogo.fx;
        this.posicionY = administracion[0].dimensionLogo.fy;
      }

      // Asignar catálogos
      this.empresas = empresas;
      this.municipios = municipios;
      this.Rutas = rutas;
      this.tipoviaje = tipoViaje;
      this.objetos = objetos;

      // Buscar vehículo después de cargar administración
      this.buscarVehiculo();

      // Cargar conductores si hay placa
      if (this.placa) {
        this.conductorService.getConductoresPorPlaca(this.placa).subscribe({
          next: (data) => {
            this.conductores = data;
          },
          error: (err) => {
            console.error("Error al cargar conductores:", err);
          }
        });
      }

      // Configurar observador de cambios en contrato
      this.formPlanilla.get("contrato")?.valueChanges.subscribe((idContrato) => {
        if (idContrato) {
          this.responsableSeleccionados = [];
          this.contratoSeleccionado = idContrato;
          this.cargarDatosContrato(idContrato);
        }
      });

      // Si hay fecha máxima del viaje, establecerla en el formulario
      if (this.fechaMaxima) {
        const fechaFormatoInput = this.formatDateForInput(this.fechaMaxima);
        this.formPlanilla.patchValue({ ffinal: fechaFormatoInput });
      }
    },
    error: (error) => {
      console.error('Error crítico al cargar parámetros iniciales:', error);
      Swal.fire(
        'Error de Carga',
        'Hubo un problema al cargar la información inicial. Por favor, recarga la página.',
        'error'
      );
    }
  });
}


    private setMinAndMaxDates(): void {
  // Obtener fecha actual en horario Colombia (GMT-5)
  const now = new Date();
  // Ajustar a Colombia restando 5 horas
  const colombiaOffsetMs = -5 * 60 * 60 * 1000;
  const colombiaDate = new Date(now.getTime() + colombiaOffsetMs);
  const year = colombiaDate.getUTCFullYear();
  const month = ("0" + (colombiaDate.getUTCMonth() + 1)).slice(-2);
  const day = ("0" + colombiaDate.getUTCDate()).slice(-2);
  const todayColombia = `${year}-${month}-${day}`;
  this.minDate = todayColombia;
  this.maxDate = todayColombia;
  }
  private cargarEmpresas(): void {
    this.empresasService.getContratistas().subscribe({
      next: (data) => (this.empresas = data),
    });
  }

  private cargarMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (data) => (this.municipios = data),
    });
  }

  private cargarConductores(): void {
    if (!this.placa) {
      console.warn("No se puede cargar conductores: placa no definida");
      return;
    }

     
    this.conductorService.getConductoresPorPlaca(this.placa).subscribe({
      next: (data) => {
        this.conductores = data;
       // console.log(this.conductores);
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
  }

 private cargarDataAdmin():void{
  this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
       
        this.administraciones = data;       
        this.altura = data[0].dimensionLogo.h;      // "8"
        this.ancho = data[0].dimensionLogo.w;       // "40"
        this.posicionX = data[0].dimensionLogo.fx;   // 10
        this.posicionY = data[0].dimensionLogo.fy;  
        
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
 }

    getEstadoColor(estado: string): string {
    switch (estado) {
      case "VIGENTE":
        return "bg-success text-white";
      case "POR VENCER":
        return "bg-warning text-dark";
      case "VENCIDO":
        return "bg-danger text-white";
      default:
        return "bg-secondary text-white";
    }
  }

  //OBJETOS DE CONTRATOS
  private cargarObjetos(): Promise<void> {
    return new Promise((resolve) => {
      this.objetoscontratosService.getObjetos().subscribe(obj => {
        this.objetos = obj;
        resolve();
      });
    });
  }

  // CARGA LAS RUTAS
  private cargarRutas(): void {
    this.rutasService.getRutas().subscribe({
      next: (data) => (this.Rutas = data),
      error: (error) => console.log("Error al obtener rutas:", error),
    });
  }

  //TIPO DE VIAJE
  private cargarTipoViaje(): void {
    this.tipoViajeService.getAll().subscribe({
      next: (data) => (this.tipoviaje = data),
      error: (error) => console.log("Error al obtener rutas:", error),
    });
  }

  // CONCATENA NOMBRE Y APELLIDOS
  private formatNombre(propietario: any): string {
    return `${propietario.primernombre || ""} ${propietario.segundonombre || ""
      } ${propietario.papellidos || ""} ${propietario.seapellidos || ""
      }`.toLowerCase();
  }


  private cargarPlacaDesdeRuta(): void {
    this.route.paramMap.subscribe((params) => {
      const placa = params.get("placa");
      if (placa) {
        this.editMode = true;
        this.placaSeleccionada = placa.toUpperCase();
        this.formNuevo.patchValue({ placa: this.placaSeleccionada });
      }
    });
  }

  private inicializarFormularios(): void {
    this.formNuevo = this.fb.group({
      servicio: ["", Validators.required],
      placa: [
        "",
        [Validators.required, Validators.pattern(/^[A-Za-z0-9]{6}$/)],
      ],
      interno: [""],
      afiliacion: [""],
      nitEmpresa: [""],
      estado: ["1"],
      clase: [""],
      marca: [""],
      modelo: [""],      
      relacion: [""],
      Idpropietario: [""],
      sucursal: [""],
      convenio: [""],
      password: [""],
      matricula: [""],
      organismo: [""],
      fechalict: [""],
      linea: [""],
      cilindraje: [""],
      motor: [""],
      titular: [""],
      capacidad: [""],
      color: [""],
      serie: [""],
      chasis: [""],
      carroceria: [""],
      combustible: [null],
      observaciones: [""],
      operaciones: [""],
      conductor: this.fb.group({
        conductor_id: [null],
      }),
    });

    this.formEmpresa = this.fb.group({
      nit: [""],
      digito: [null],
      nombre: [null],
      direccion: [null],
      ciudad: [null],
      telefono: [
        null,
        [
          Validators.min(1000000),
          Validators.max(9999999999),
          Validators.maxLength(10),
          Validators.pattern(/^\d{0,10}$/),
        ],
      ],
      celular: [
        null,
        [
          Validators.min(1000000),
          Validators.max(9999999999),
          Validators.maxLength(10),
          Validators.pattern(/^\d{0,10}$/),
        ],
      ],
      email: [null],
      observaciones: [null],
      eps: [false],
      arl: [false],
      afp: [false],
      ces: [false],
      ccf: [false],
      bancos: [false],
      transporte: [false],
      colegio: [false],
      cda: [false],
      taller: [false],
      eds: [false],
      contratista: [false],
      proveedor: [false],
      aseguradora: [false],
      almacen: [false],
      serviteca: [false],
      estado: [1],
    });

    this.formContrato = this.fb.group({
      id: [""],
      numero: [null],
      cedula: [null],
      contratante: [null],
      direccion: [null],
      ciudad: [null],
      telefono: [null],
      mail: [null],
      inicio: [null],
      fin: [null],
      origen: [null],
      destino: [null],
      tipo: [null],
      idres: [null],
      responsable: [null],
      dirresponsble: [null],
      telres: [null],
      cuires: [null],
      mailresp: [null],
      pasajeros: [null],
      valor: [null],
      disponibilidad: [{ value: 0, disabled: true }],
    });


    this.formPlanilla = this.fb.group(
      {
           
        empresa: [null],
        nite: [null],
        contrato: [null],       
        nitc: [null],
        objeto: [{ value: false, disabled: true }],
        ruta: [null],
        terceros: [{ value: false, disabled: true }],
        ut: [{ value: false, disabled: true }],
        conv: [{ value: false, disabled: true }],
        consor: [{ value: false, disabled: true }],
        finicial: [null, Validators.required],
        ffinal: [null, Validators.required],
        origen: [null],
        destino: [null],
        placa: [null],
        modelo: [null],
        marca: [null],
        clase: [null],
        interno: [null],
        operaciones: [null],      
        direccion: [null],
        telefono: [null],
        email: [null],
        web: [null],       
        viaje: [null],
        estado: ["1"],
        ip: [null],
        disponibilidad: [{ value: '', disabled: true }],
        complemento: [null],
       
      },
      {
        validators: [this.validarFechas.bind(this)],
      }
    );






    this.rutaForm = this.fb.group({
      id: [""],
      origen: [null, [Validators.required]],
      destino: [null, [Validators.required]],
      nombre: [null, [Validators.required, noEspaciosValidator]],
      ruta: [null, [Validators.required, noEspaciosValidator]],
      estado: ["1", [Validators.required]],
    });
  }

  validarFechas(formGroup: AbstractControl): ValidationErrors | null {
    const finicial = formGroup.get('finicial')?.value;
    const ffinal = formGroup.get('ffinal')?.value;

    if (!finicial || !ffinal) return null;

    const fechaSalida = new Date(finicial);
    const fechaRegreso = new Date(ffinal);

    let fechaLimite: Date | null = null;

    if (this.fechaMaximaSalida) {
      fechaLimite = new Date(this.fechaMaximaSalida);
    }

    if (fechaRegreso < fechaSalida) {
      // Mostrar alerta con SweetAlert2
     
        Swal.fire({
          icon: 'warning',
          title: 'Fecha inválida',
          text: 'La fecha de regreso debe ser posterior a la fecha de salida.',
          confirmButtonText: 'Aceptar'
        }).then(() => {
          // Limpia la fecha de salida
          this.isEnableFuec =false;
          this.formPlanilla.get('ffinal')?.reset();
        });
      return { fechaInvalida: true };
    }

    if (fechaLimite && fechaRegreso > fechaLimite) {
      
      return { fechaFutura: true };
    }

    return null;
  }


  listarEmpresas(): void {
    this.empresasService.getContratistas().subscribe({
      next: (data) => {
        // Añadimos la propiedad 'label' para usarla en el ng-select
        this.empresas = data.map((empresa: any) => ({
          ...empresa,
          label: `${empresa.nit} - ${empresa.nombre}`
        }));
      },
      error: (err) => {
        console.error("❌ Error al obtener contratistas:", err);
      },
    });
  }

  listarActivos(): void {
    const placaFiltrada = this.placaSeleccionada.trim().toUpperCase();

    this.vehicleService.getVehiclePublicoByPlaca(placaFiltrada).subscribe({
      next: (data) => {
        if (data?.placa) {
          this.vehiculoSeleccionado = data;

          // Asignar a los inputs individuales
          this.placa = data.placa;
          this.modelo = data.modelo;
          this.marca = data.marcas?.marca ?? "";
          this.tipos = data.tipoVehiculo?.tipos ?? "";
          this.interno = data.interno;
          this.numero_tarjeta =
            data.tarjetasOperaciones?.[0]?.numero_tarjeta ?? "";

          // Asignar al formulario reactivo también si lo usas
          this.formPlanilla.patchValue({
            placa: this.placa,
            modelo: this.modelo,
            marca: this.marca,
            clase: this.tipos,
            operaciones: this.numero_tarjeta,
            interno: this.interno,
          });
        } else {
          this.limpiarFormularioVehiculo();
        }
      },
      error: () => {
        this.limpiarFormularioVehiculo();
      },
    });
  }

  limpiarFormularioVehiculo(): void {
    this.placa = "";
    this.modelo = "";
    this.marca = "";
    this.tipos = "";
    this.interno = "";
    this.numero_tarjeta = "";
    //this.pasajeros = [];
    this.conductoresSeleccionados = [];
    this.conductores.forEach(conductor => {
  conductor.seleccionado = false;
});
    this.opcionSeleccionada = null;
    this.conductores = [];
    this.formPlanilla.reset();
  }

  listarConductor(placa: string): void {
    //console.log('Filtrando conductores por placa:', placa);
    this.conductores = this.conductores.filter((c) => c.vehiculo_id === placa);
    //console.log('Conductores filtrados:', this.conductores);
  }

  buscarVehiculo() {
    const placa = this.formNuevo.get("placa")?.value?.trim();
    //console.log("Placa ingresada:", placa);

    if (placa) {
      this.vehicleService.getVehiclePublicoByPlaca(placa).subscribe({
        next: (vehicleData) => {
          //console.log("Respuesta del servicio:", vehicleData);

          if (vehicleData) {
         //   console.log(vehicleData);
           this.vehicle = vehicleData;
        //    this.editarSeleccion = { placa: this.vehicle.placa };
        //    this.placaSeleccionada = this.vehicle.placa;
        //    this.vehiculoSeleccionado = this.vehicle;
              
          this.placa = vehicleData.vehicle.placa;
          this.modelo = vehicleData.vehicle.modelo;
          this.marca =vehicleData.vehicle.marcas.marca ?? "";
          this.tipos = vehicleData.vehicle.tipoVehiculo.tipos ?? "";
          this.interno = vehicleData.vehicle.interno;
          this.numero_tarjeta =
            vehicleData.vehicle.tarjetasOperaciones?.[0]?.numero_tarjeta ?? "";

          // Asignar al formulario reactivo también si lo usas
          this.formPlanilla.patchValue({
            placa: this.placa,
            modelo: this.modelo,
            marca: this.marca,
            clase: this.tipos,
            operaciones: this.numero_tarjeta,
            interno: this.interno,
          });
        //  console.log(vehicleData.vehicle.tipoRelacion.id);
           this.opcionSeleccionada = vehicleData.vehicle.tipoRelacion.relacion; // ← lo que recibes
            if (vehicleData.vehicle.tipoRelacion.id==8){
              this.convenio = 1;
            }else{
              this.convenio = 0;
            }
           //console.log(this.opcionSeleccionada);
            // this.listarActivos();
            //  this.listarConductor(this.vehicle.placa);
            // Filtrar la lista por placa
            //this.vehicles = this.vehiclesFullList.length
            //  ? this.vehiclesFullList.filter(
            //    (v) => v.placa === this.vehicle.placa
            //  )
            // : [this.vehicle];
          }
        },
      });
    }
  }


  conductoresForm: any[] = [
    {
      conductorSeleccionado: null,
      cedula: "",
      licencia: "",
      vencelic: "",
      fechacobeps: "",
    },
  ];

 
  /**
   * Carga datos del contratista y sus contratos de forma optimizada
   * @param silenciarAlerta - Si true, no muestra alertas de error (útil para cargas automáticas)
   */
  cargaContratista(silenciarAlerta: boolean = false): void {
    // Limpiar estado previo
    this.resetContratoState();

    // Validar NIT seleccionado
    const nit = this.empresaSeleccionada;
    if (!nit) {
      if (!silenciarAlerta) {
        Swal.fire('Atención', 'Por favor selecciona una empresa contratista.', 'warning');
      }
      return;
    }

    // Activar indicador de carga
    this.loadingContratista = true;
    //console.log('Iniciando carga - loadingContratista:', this.loadingContratista);

    // Cargar empresa y contratos en paralelo
    forkJoin({
      empresa: this.empresasService.getEmpresaByNit(nit).pipe(
        catchError(error => {
          console.error('Error al buscar empresa:', error);
          return of(null);
        })
      ),
      contratos: this.contratoService.getContratoPorCedula(Number(nit)).pipe(
        catchError(error => {
          console.error('Error al buscar contratos:', error);
          return of([]);
        })
      )
    }).pipe(
      finalize(() => {
        // Delay mínimo para asegurar visibilidad del spinner (500ms)
        setTimeout(() => {
          this.loadingContratista = false;
         // console.log('Carga finalizada - loadingContratista:', this.loadingContratista);
        }, 500);
      })
    ).subscribe({
      next: ({ empresa, contratos }) => {
        // Procesar datos de la empresa
        if (!empresa) {
          if (!silenciarAlerta) {
            Swal.fire(
              'No encontrada',
              'No se encontró ninguna empresa con el NIT proporcionado.',
              'info'
            );
          }
          return;
        }

        this.empresa = empresa;
       // console.log('Empresa cargada:', empresa);

        // Actualizar formulario con datos de la empresa
        this.formPlanilla.patchValue({
          nitc: empresa.nombre,
        });

        // Procesar contratos
        this.numeroContratos = contratos || [];
        this.isContratos = this.numeroContratos.length > 0;

        if (this.numeroContratos.length === 0 && !silenciarAlerta) {
          Swal.fire(
            'Sin Contratos',
            'El contratante seleccionado no tiene contratos registrados y/o vigentes.',
            'info'
          );
        } else if (this.numeroContratos.length > 0) {
         // console.log(`${this.numeroContratos.length} contrato(s) encontrado(s)`);
        }
      },
      error: (error) => {
        console.error('Error crítico en cargaContratista:', error);
        if (!silenciarAlerta) {
          Swal.fire(
            'Error',
            'Hubo un problema al cargar los datos del contratista. Por favor, intenta nuevamente.',
            'error'
          );
        }
        this.resetContratoState();
      }
    });
  }

  /**
   * Resetea el estado relacionado con contratos y responsables
   * @private
   */
  private resetContratoState(): void {
    this.datosResp = '';
    this.numeroContratos = [];
    this.formPlanilla.get('contrato')?.reset();
    this.contratoMostrado = null;
    this.contratoSeleccionado = null;
    this.contratoBuscado = false;
    this.isContratos = false;
    this.isResponsable = false;
  }

  /**
   * Método separado para cargar solo contratos (deprecado - usar cargaContratista en su lugar)
   * @deprecated Utilizar cargaContratista que carga empresa y contratos en paralelo
   */
  cargaContratos(nit: string | number): void {
    console.warn('Método cargaContratos está deprecado. Usar cargaContratista en su lugar.');
    
    this.contratoService.getContratoPorCedula(Number(nit)).subscribe({
      next: (response) => {
        this.numeroContratos = response || [];
        this.isContratos = this.numeroContratos.length > 0;
        
        if (this.numeroContratos.length === 0) {
          Swal.fire(
            'SIN RESULTADOS',
            'El contratante seleccionado no tiene contratos registrados y/o contratos vigentes.',
            'info'
          );
        }
      },
      error: (error) => {
        console.error('Error al cargar contratos:', error);
        this.numeroContratos = [];
        this.isContratos = false;

        Swal.fire(
          'Error',
          'No se pudo obtener el listado de contratos.',
          'error'
        );
      }
    });
  }

  openModalEmpresa(content: any, empresa?: any): void {
    if (empresa) {
      this.editMode = true;
      this.empresaselecionada = empresa;
      this.formEmpresa.patchValue(empresa); // Carga datos en el formulario para editar      
    } else {
      this.editMode = false;
      this.formEmpresa.reset(); // Limpia el formulario para un nuevo registro
    }

    const modalRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });

    this.modalEmpresaRef = modalRef;
  }

  guardarEmpresa(modalRef: NgbModalRef): void {
    this.validate = true;
    const datos = { ...this.formEmpresa.value };

    // Validación de correo
    const email = datos.email;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      this.mostrarAlerta(
        "Email inválido",
        "Correo no válido. Ej: usuario@dominio.com",
        "info"
      );
      return;
    }

    // Validar campos obligatorios con mensajes personalizados
    const camposObligatorios: {
      campo: string;
      mensaje: string;
      ref?: ElementRef;
    }[] = [
        {
          campo: "nit",
          mensaje: "Por favor, ingresa un número de documento",
          ref: this.inputNit,
        },
        {
          campo: "digito",
          mensaje: "Por favor, ingresa un dígito de verificación",
          ref: this.inputCodigo,
        },
        {
          campo: "nombre",
          mensaje: "Por favor, ingresa un nombre",
          ref: this.inputNombre,
        },
        {
          campo: "direccion",
          mensaje: "Por favor, ingresa una dirección",
          ref: this.inputDireccion,
        },
        {
          campo: "ciudad",
          mensaje: "Por favor, ingresa una ciudad",
          ref: this.inputCiudad,
        },
        {
          campo: "celular",
          mensaje: "Por favor, ingresa un número de celular",
          ref: this.inputCelular,
        },
        /* {
          campo: "email",
          mensaje: "Por favor, ingresa un correo electrónico",
          ref: this.inputEmail,
        }, */
      ];

    for (const { campo, mensaje, ref } of camposObligatorios) {
      const valor = this.formEmpresa.get(campo)?.value;
      
      // Para el campo digito, aceptar 0 como válido
      if (campo === 'digito') {
        if (valor === null || valor === undefined || valor === '') {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      } else {
        if (!valor) {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      }
    }

    // Convertir checkboxes a 1/0
    const checkboxKeys = [
      "eps",
      "arl",
      "afp",
      "ces",
      "ccf",
      "bancos",
      "transporte",
      "colegio",
      "cda",
      "taller",
      "eds",
      "contratista",
      "proveedor",
      "aseguradora",
      "almacen",
      "serviteca",
    ];
    checkboxKeys.forEach((k) => (datos[k] = datos[k] ? 1 : 0));

    datos.estado = 1; // Activar empresa al guardar
    datos.contratista = 1; // Marcar como contratista

    this.empresasService.createEmpresa(datos).subscribe({
      next: (empresaCreada) => {
        modalRef.close();

        if (this.esUsuarioTenant) {
          // Obtener contratistas actuales del usuario, agregar el nuevo y guardar
          this.usuarioContratistaService.getContratistaPorUsuario(this.usuarioLogin?.id).subscribe({
            next: (asignados: any[]) => {
              const nitsActuales = (asignados || []).map((c: any) => c.nit || c.empresa_nit || c);
              const nuevoNits = [...nitsActuales, empresaCreada.nit];

              this.usuarioContratistaService.asignarContratistas(this.usuarioLogin?.id, nuevoNits).subscribe({
                next: () => {
                  // Recargar lista de empresas del usuario tenant
                  this.usuarioContratistaService.getContratistaPorUsuario(this.usuarioLogin?.id).subscribe({
                    next: (data) => {
                      this.empresas = data;
                      this.empresaSeleccionada = empresaCreada.nit;
                    },
                    error: (err) => console.error("Error al recargar empresas del usuario:", err)
                  });
                },
                error: (err) => console.error("Error al asignar contratista al usuario:", err)
              });
            },
            error: (err) => console.error("Error al obtener contratistas del usuario:", err)
          });
        } else {
          this.empresasService.getContratistas().subscribe({
            next: (data) => {
              this.empresas = data;
              this.empresaSeleccionada = empresaCreada.nit;
            },
            error: (err) => {
              console.error("Error al actualizar contratistas:", err);
            },
          });
        }

        Swal.fire("Éxito", "Empresa registrada correctamente", "success");
      },
      error: () => {
        Swal.fire("Error", "No se pudo registrar la empresa", "error");
      },
    });
  }

  trackByNit(index: number, item: any): any {
    return item.nit;
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
      confirmButtonText: 'Aceptar', // ← Texto del botón
      
    });
  }

  openModalContrato(content: any): void {
    console.log(this.empresaSeleccionada);
    this.editMode = false;
    this.contratoSeleccionado = null;
    this.activePanelmodel = ["static-1"];
    this.formContrato.reset(); // Limpia el formulario
    this.mostrarAvisoDisponibilidad = true;
    this.mostrarOrigenDestino = false;
    if(this.empresaSeleccionada){
      
      this.mostrarEmpresaSeleccionada();
    }
    
    // this.mostrarEmpresaSeleccionada(true); // Llena datos si hay empresa seleccionada

    this.modalContratoRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });
  }

 guardarContrato(modalRef: NgbModalRef): void {
    this.validate = true;

  const tipoContrato = this.formContrato.get('tipo')?.value;

let camposRequeridos = [
  {
    campo: "idres",
    mensaje: "el CC o NIT del responsable",
    ref: this.inputIdres,
  },
  {
    campo: "responsable",
    mensaje: "el nombre del responsable",
    ref: this.inputResponsable,
  },
  {
    campo: "dirresponsble",
    mensaje: "la dirección responsable",
    ref: this.inputDiResponsable,
  },
  { campo: "cuires", mensaje: "la ciudad", ref: this.inputCuires },
  {
    campo: "telres",
    mensaje: "el teléfono del responsable",
    ref: this.inputTelefono,
  },
 /*  {
    campo: "mailresp",
    mensaje: "el email del responsable",
    ref: this.inputMailResponsable,
  }, */
  { campo: "tipo", mensaje: "un objeto de contrato", ref: this.inputTipo },
  { campo: "inicio", mensaje: "la fecha de inicio", ref: this.inputInicio },
  { campo: "fin", mensaje: "la fecha de finalización", ref: this.inputFin },
 /*  {
    campo: "pasajeros",
    mensaje: "el número de pasajeros",
    ref: this.inputPasajeros,
  },
  {
    campo: "valor",
    mensaje: "el valor del servicio",
    ref: this.inputValor,
  }, */
];

// Solo agregar origen y destino si tipo === 4
// Solo agregar origen y destino si tipo === 4
if (tipoContrato === 4) {
  camposRequeridos.push(
    { campo: "origen", mensaje: "el origen", ref: this.inputOrigenCont },
    { campo: "destino", mensaje: "el destino", ref: this.inputDestinoCont }
  );
}else{
this.formContrato.patchValue({
        origen: 0,
        destino:0 
           });

}

    for (const campo of camposRequeridos) {
      const valor = this.formContrato.get(campo.campo)?.value;
      if (!valor) {
        this.mostrarAlerta2(
          "Campo requerido",
          `Por favor, ingresa ${campo.mensaje}`,
          "info"
        );

        setTimeout(() => {
          requestAnimationFrame(() => {
            const input = campo.ref?.nativeElement;
            if (input) {
              input.scrollIntoView({ behavior: "smooth", block: "center" });
              input.focus();
              if (typeof input.value === "string") {
                input.setSelectionRange?.(
                  input.value.length,
                  input.value.length
                );
              }
            }
          });
        }, 200);

        return;
      }
    }

    // Construir datos
    const datosContrato: any = {
      ...this.formContrato.value,      
      estado: 1,
    };

    // Eliminar campos nulos que puedan generar errores
    Object.keys(datosContrato).forEach((key) => {
      if (datosContrato[key] === null) {
        delete datosContrato[key];
      }
    });

   // console.log("Datos a enviar:", datosContrato);

    if (this.editMode && this.contratoSeleccionado) {
      // 🔁 Editar contrato
      this.contratoService
        .updateContratoPorId(this.contratoSeleccionado, datosContrato)
        .subscribe({
          next: () => {
            modalRef.close();
            //this.resetFormulario();
            this.mostrarAlerta2(
              "Éxito",
              "Contrato actualizado correctamente.",
              "success"
            );
          //  this.listarContratos();
          },
          error: (error) => {
            this.mostrarAlerta2(
              "Error",
              error.message || "Error al actualizar el contrato",
              "error"
            );
          },
        });
    } else {
      // ✅ Crear contrato
      this.contratoService.createContrato(datosContrato).subscribe({
        next: () => {
          modalRef.close();
        
          this.mostrarAlerta2(
            "Éxito",
            "Contrato creado correctamente.",
            "success"
          );
          if(this.empresa){
                  this.cargaContratos(this.empresa?.nit);
             }
                    
          //this.listarContratos();
        },
        error: (error) => {
          this.mostrarAlerta2(
            "Error",
            error.message || "Error al guardar el contrato",
            "error"
          );
        },
      });
    }
  }

 

  private mostrarAlerta2(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  onDisponibilidadChange(valor: number | string): void {
    const disponibilidad = this.normalizarDisponibilidad(valor);
    const tipo = Number(this.formContrato.get("tipo")?.value);

    if (
      disponibilidad === 1 &&
      (tipo === 2 || tipo === 5) &&
      this.mostrarAvisoDisponibilidad
    ) {
      this.mostrarAlerta2(
        "Disponibilidad total activa",
        "Si seleccionas “Sí”, las rutas no se habilitarán al momento de hacer el extracto (FUEC). Para activarlas, selecciona “No”.",
        "info"
      );
      this.mostrarAvisoDisponibilidad = false;
    }

    if (disponibilidad !== 1) {
      this.mostrarAvisoDisponibilidad = true;
    }

    this.mostrarOrigenDestino = tipo === 4;

    if (!this.mostrarOrigenDestino) {
      this.formContrato.patchValue(
        {
          origen: null,
          destino: null,
        },
        { emitEvent: false }
      );
    }
  }

  private normalizarDisponibilidad(valor: any): number {
    if (valor === true || valor === 1 || valor === "1") {
      return 1;
    }

    if (typeof valor === "string") {
      const valorNormalizado = valor.trim().toUpperCase();
      if (valorNormalizado === "SI" || valorNormalizado === "SÍ") {
        return 1;
      }
    }

    return 0;
  }

  trasladarDatosEmpresa(): void {
    
    if (this.empresaMostrada && this.formContrato) {
       const contrato = this.formContrato.value;
      this.formContrato.patchValue({
        idres: contrato.cedula,
        responsable: contrato.contratante,
        dirresponsble: contrato.direccion,
        cuires: contrato.ciudad,
        telres: contrato.telefono,
        mailresp: contrato.mail
      });

      // Abrir el panel con ID "static-2"
      this.activePanelmodel = ["static-2"];
    }
  }

  getContratosPorCedula(cedula: number): void {
    this.contratoService.getContratoPorCedula(cedula).subscribe({
      next: (response) => {
      //  console.log("📦 mostrarCedula:", response); // ⬅️ Asegúrate de que contiene idres, responsable, etc.
        this.numeroContratos = response;
        this.contratoBuscado = true;
      },
      error: (err) => {
        this.numeroContratos = [];
        this.contratoBuscado = true;
        Swal.fire(
          "Sin resultados",
          err?.error?.error || "No se encontró ningún contrato con esa cédula.",
          "info"
        );
      },
    });
  }

  cargarDatosContrato(numeroContratos: string | number | null): void {
    
    
    const objetoControl = this.formPlanilla.get("objeto");
    const objetoffinal = this.formPlanilla.get("ffinal");
    const objetofinicial = this.formPlanilla.get("finicial");
    objetoffinal?.reset();
    objetofinicial?.reset();

    if (!numeroContratos) {
      this.onObjetoChange(null);
      objetoControl?.enable(); // Permitir selección manual si no hay contrato
      return;
    }
    
    const contrato = this.numeroContratos.find(
      (c: any) => `${c.numero}` === `${numeroContratos}`
    );

    if (contrato) {
      const objetoSeleccionado = this.objetos.find(
        (obj: any) => Number(obj.id) === Number(contrato.tipo)
      );
      const objetoIdContrato = Number(contrato.tipo);
      
      this.datosResp = contrato;
      this.isResponsable = true;

      // Setear el ID del objeto desde el contrato, incluso si no está en this.objetos filtrado
      objetoControl?.setValue(objetoIdContrato);

      if(this.esUsuarioTenant){
        this.usuarioObjetosContratosService.getByUsuario(this.usuarioLogin?.id).subscribe({
          next: (data: any[]) => {
            console.log("Objetos de contrato del usuario:", data);
            const tieneAcceso = data.some(
              (uo) => Number(uo.id) === objetoIdContrato && Number(uo.isFuec) === 1
            );
            if (!tieneAcceso) {
              Swal.fire({
                icon: 'error',
                title: 'Acceso denegado',
                text: 'No tienes permiso para usar este tipo de objeto de contrato.',
                confirmButtonText: 'Aceptar'
              }).then(() => {
                this.formPlanilla.get('contrato')?.reset();
                objetoControl?.reset();
                this.isResponsable = false;
                this.datosResp = null;
              });
            }
          },
          error: (err) => {
            console.error("Error al verificar permisos de objeto de contrato:", err);
          },
        });
      }

      if (objetoSeleccionado) {

       // console.log("Objeto seleccionado:", objetoSeleccionado);
       // console.log("Contrato seleccionado:", contrato);
        if (objetoIdContrato === 4) {
          const origenContrato = this.obtenerNombreMunicipioContrato(contrato, "origen");
          const destinoContrato = this.obtenerNombreMunicipioContrato(contrato, "destino");

          this.formPlanilla.patchValue({
            origen: origenContrato,
            destino: destinoContrato,
          });
        } 
        // 👇 Ejecutar lógica asociada (opcional)
        this.onObjetoChange(String(objetoIdContrato));
        // 👇 Deshabilitar si quieres bloquear edición
        objetoControl?.disable();

        if (history.state.fechaMaxima && contrato.fin) {

          this.fechaMaximaSalida = this.getFechaMenor(history.state.fechaMaxima, contrato.fin);
         // console.log(this.fechaMaximaSalida);


          
        }

       // console.log(contrato.inicio);
          // Asignar fecha mínima de salida igual a la fecha de inicio del contrato
          if (contrato.inicio) {
            const inicioDate = new Date(contrato.inicio);
            const hoy = new Date();
            inicioDate.setHours(0,0,0,0);
            hoy.setHours(0,0,0,0);
            if (inicioDate < hoy) {
            //  console.log('La fecha de inicio del contrato es anterior a hoy.');
              this.fechaMinimaSalida = this.formatDateForInput(hoy);
            } else {
             // console.log('La fecha de inicio del contrato es posterior a hoy.');
             // console.log((contrato.inicio));
              this.fechaMinimaSalida = this.formatDateForInput(contrato.inicio);
            }
          } else {
            this.fechaMinimaSalida = '';
          }
        //VALIDAR SI ES DISPONIBIDAD TOTAL DEL VEHICULO
        //console.log(contrato.dispobilidad);

        const disponibilidadControl = this.formPlanilla.get("disponibilidad");
        const origenControl = this.formPlanilla.get("origen");
        const destinoControl = this.formPlanilla.get("destino");
        const rutaControl = this.formPlanilla.get("ruta");
      //    console.log(disponibilidadControl);
        //  console.log(contrato.disponibilidad);
        if(contrato.disponibilidad==1){
          //muestra el campo de disponibilidad
           disponibilidadControl?.enable();
           this.isDisponilidad =true;
           // Bloquear origen, destino y ruta cuando hay disponibilidad
           origenControl?.disable();
           destinoControl?.disable();
           rutaControl?.disable();
           
          // console.log(this.isDisponilidad);
          // console.log("entro");
        }else{
          //oculta y limpia
            this.isDisponilidad =false;
           disponibilidadControl?.disable();
           // Habilitar origen, destino y ruta cuando NO hay disponibilidad
           origenControl?.enable();
           destinoControl?.enable();
           rutaControl?.enable();
        }

      const territorial = this.administraciones[0].territorial.toString();
      const resolucion = this.administraciones[0].resolucion.toString().padStart(4, '0');
      const habilitacion = this.administraciones[0].habilitacion.toString();
      const anioActual = new Date().getFullYear().toString();
      const contratoNumero = contrato.numero.toString();

      this.codigoUnificado = `${territorial}${resolucion}${habilitacion}${anioActual}`;

    
        //RESPONSABLE
        this.idReponsable =       contrato.idres;
        this.nombreResponsable= contrato.responsable;
        this.telefonoResponsable =  contrato.telres;
        this.direccionResponsable = contrato.dirresponsble;

      //DATOS DE LA EMPRESA        

      const direccion = this.administraciones[0]?.direccion || null;
      const email = this.administraciones[0]?.email || null;
      const nite = this.administraciones[0]?.nit || null;
      const telefono = this.administraciones[0]?.telefono || null;
    //  const empresa = this.administraciones[0]?.empresa || null;

      this.formPlanilla.patchValue({
        direccion: direccion,
        email: email,
        nite: nite,
        telefono: telefono,
       // empresa: empresa
      });
              
     
        }

       
    }
  }

  ListadoContratos() {
    this.router.navigate(["/contratos/contratos"]);
  }

  onRutaChange(rutaSeleccionada: any): void {
    if (
      rutaSeleccionada &&
      rutaSeleccionada.nombre &&
      rutaSeleccionada.nombre.includes(" - ")
    ) {
      const [origen, destino] = rutaSeleccionada.nombre
        .split(" - ")
        .map((s: string) => s.trim());
      this.formPlanilla.patchValue({ origen, destino });
    } else {
      this.formPlanilla.patchValue({ origen: "", destino: "" });
    }
  }

  private obtenerNombreMunicipioContrato(
    contrato: any,
    tipo: "origen" | "destino"
  ): string {
    const keyObj = tipo === "origen" ? "municipioOrigen" : "municipioDestino";
    const keyRaw = tipo === "origen" ? "origen" : "destino";

    const municipioDesdeObjeto =
      contrato?.[keyObj]?.MUNICIPIO ??
      contrato?.[keyObj]?.municipio ??
      contrato?.[keyObj]?.nombre ??
      null;

    if (municipioDesdeObjeto) {
      return String(municipioDesdeObjeto).trim();
    }

    const valorRaw = contrato?.[keyRaw];
    if (valorRaw === null || valorRaw === undefined || valorRaw === "") {
      return "";
    }

    if (typeof valorRaw === "string" && isNaN(Number(valorRaw))) {
      return valorRaw.trim();
    }

    const municipioEncontrado = this.municipios?.find(
      (m: any) => String(m?.IDMUN) === String(valorRaw)
    );

    return municipioEncontrado?.MUNICIPIO ?? String(valorRaw);
  }

  onObjetoChange(valor: string | null): void {
    const disponibilidadControl = this.formPlanilla.get("disponibilidad");
    
    if (valor === 'TRANSPORTE EMPRESARIAL') {
      disponibilidadControl?.enable();
    } else {
      disponibilidadControl?.disable();
    }
  }

  guardarPlanilla(): void {
    //console.log(this.responsableSeleccionados);
    
    
    if (this.esUsuarioTenant) {
      // ❌ Bloquear acción para usuarios tenant
     // console.log("objeto seleccionado:", this.formPlanilla.get("objeto")?.value);
       this.loadingService.ocultar();
      /* if (this.formPlanilla.get("objeto")?.value != 4) {
        this.mostrarAlerta(
          "Acción no permitida",
          "Tus permisos no pueden crear FUEC con este tipo de objeto de contrato. Solo puede crear FUEC para Grupo Específico de Usuarios'.",
          "warning"
        );
        return;
      } */
 // ✅ Activar validación visual
      this.validate = true;

      // 🧪 Validación personalizada de campos específicos
      const camposRequeridos = [
        { campo: "empresa", mensaje: "seleccione un contratante", input: this.inputEmpresa },
        { campo: "contrato", mensaje: "seleccione un contrato", input: this.inputContrato },
        { campo: "finicial", mensaje: "ingrese una fecha de salida", input: this.inputInicial },
        { campo: "ffinal", mensaje: "ingrese una fecha de regreso", input: this.inputFinal },
        { campo: "objeto", mensaje: "seleccione un objeto de contrato", input: this.inputObjeto },
        { campo: "viaje", mensaje: "seleccione un tipo de viaje", input: this.inputTipoViaje },
      ];

      // Solo validar origen y destino si NO es disponibilidad
      if (!this.isDisponilidad) {
        camposRequeridos.push(
          { campo: "origen", mensaje: "seleccione una ciudad de origen", input: this.inputOrigen },
          { campo: "destino", mensaje: "seleccione una ciudad de destino", input: this.inputDestino }
        );
      }
     
      
      for (const { campo, mensaje, input } of camposRequeridos) {
        const valor = this.formPlanilla.get(campo)?.value;
        if (valor === null || valor === undefined || (typeof valor === "string" && valor.trim() === "")) {
          this.mostrarAlerta("Campo requerido", `Por favor, ${mensaje}`, "info");
          this.loadingService.ocultar();
          input?.nativeElement?.focus?.();

          return;
        }
      }

      // 🔎 Validar campo disponibilidad si isDisponilidad es true
      if (this.isDisponilidad) {
        const disponibilidad = this.formPlanilla.get('disponibilidad')?.value;
        if (!disponibilidad || disponibilidad.trim() === '') {
          this.mostrarAlerta(
            "Campo requerido",
            "Por favor, ingrese la disponibilidad del vehículo antes de continuar.",
            "info"
          );
          
          this.loadingService.ocultar();
          return;
        }
      }

      if (!this.placa) {
        this.mostrarAlerta(
          "Campo requerido",
          "Por favor, recarga la pagina",
          "info"
        );
        this.loadingService.ocultar();
        return;
      }

      // 🔎 Validar si hay conductores
      if (!this.conductoresSeleccionados || this.conductoresSeleccionados.length === 0) {
        this.mostrarAlerta(
          "¡Importante!",
          "Por favor, seleccione al menos un conductor antes de continuar.",
          "info"
        );
        this.loadingService.ocultar();
        return;
      }

      // 🧠 Asignación de conductores (hasta 3)
      this.conductoresSeleccionados.forEach((c, index) => {
        const { conductor_id, nombre, licencia, vencimientoLicencia } = c;
        switch (index) {
          case 0:
            [this.cedula, this.conductor, this.licencia, this.vigencia] =
              [conductor_id, nombre, licencia, vencimientoLicencia];
            break;
          case 1:
            [this.cedula1, this.conductor1, this.licencia1, this.vigencia1] =
              [conductor_id, nombre, licencia, vencimientoLicencia];
            break;
          case 2:
            [this.cedula2, this.conductor2, this.licencia2, this.vigencia2] =
              [conductor_id, nombre, licencia, vencimientoLicencia];
            break;
        }
      });

      // 🧾 Recolectar datos del formulario
      const datosFormulario = this.formPlanilla.value;
      const raw = this.formPlanilla.getRawValue(); // incluye campos deshabilitados


      // 🧱 Armar objeto para el backend
      // Calcular fecha y hora actual de Colombia
      const fechaColombia = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Bogota' }); // 'YYYY-MM-DD'
      const horaColombia = new Date().toLocaleTimeString('en-GB', { timeZone: 'America/Bogota', hour12: false }); // 'HH:mm:ss'
      const fechahora = `${fechaColombia} ${horaColombia}`;

      // console.log(fechaColombia);
      // console.log(horaColombia);
      // console.log(fechahora);

     // console.log(datosFormulario);
      
      const datos = {
        ...datosFormulario,
        objeto: raw.objeto,
        terceros: 0,
        ut: 0,
        conv: this.convenio,
        consor: 0,
        cedula: this.cedula,
        conductor: this.conductor,
        licencia: this.licencia,
        vigencia: this.vigencia,

        cedula1: this.cedula1,
        conductor1: this.conductor1,
        licencia1: this.licencia1,
        vigencia1: this.vigencia1,

        cedula2: this.cedula2,
        conductor2: this.conductor2,
        licencia2: this.licencia2,
        vigencia2: this.vigencia2,

        idresponsable: this.idReponsable,
        responsable: this.nombreResponsable,
        telefonor: this.telefonoResponsable,
        direccionr: this.direccionResponsable,
        nfuec: this.codigoUnificado,
        usuario: this.usuarioLogin?.usuario || this.usuarioLogin?.email || this.usuarioLogin?.username || 'desconocido',
        registro: fechaColombia,
        hora: horaColombia,
        fechahora: fechahora,

      };

      //console.log("📤 Datos enviados:", datos);
    
       this.loadingService.mostrar(
      'Guardando...',
      [      
      ], "Enviando Fuec"
    );
      // 📩 Enviar al backend
      this.planillaService.createPlanilla(datos).subscribe({
        next: (response) => {
          console.log(response);
          const planillaCreada = response.Planilla;
          const idfuec = planillaCreada.idfuec;

         // console.log("🆔 ID del FUEC:", idfuec);
          if (idfuec) {
            //insertar los pasajeros asociados al FUEC
            this.pasajeros.forEach(pasajero => {
          //    console.log("Insertando pasajero:", pasajero);
              pasajero.extracto_id = idfuec;
              this.pasajerosService.crear(pasajero).subscribe({
                next: (response) => {
                  console.log("Pasajero insertado:", response);
                },
                error: (error) => {
                  console.error("Error insertando pasajero:", error);
                }
              });
            });
          this.loadingService.mostrar(
              'Guardando...',
              [
                {
                  id: 'enviando',
                  nombre: 'Guardando',
                  icono: '📝',
                  visible: true,
                  estado: 'completado'
                }, 
              ],
              "Guardando Fuec"
            );
            // Generar FUEC solo si se creó correctamente
            this.generarFuec(planillaCreada); // puedes pasar toda la info aquí
            this.mostrarAlerta2("Éxito", "FUEC creado correctamente", "success");
          }
          this.loadingService.ocultar();
          Swal.fire({
            icon: 'success',
            title: 'Registro guardado',
            text: 'El registro fue creado y el PDF está listo.',
            timer: 3000,
            showConfirmButton: false,
          });

          // Limpiar formulario después de guardar exitosamente
          this.limpiarFormulario();

        },
        error: (error) => {
          this.mostrarAlerta2("Error", error?.message || "Error al guardar el Extracto", "error");
        }
      });

    } else {

      // ✅ Activar validación visual
      this.validate = true;

      // 🧪 Validación personalizada de campos específicos
      const camposRequeridos = [
        { campo: "empresa", mensaje: "seleccione un contratante", input: this.inputEmpresa },
        { campo: "contrato", mensaje: "seleccione un contrato", input: this.inputContrato },
        { campo: "finicial", mensaje: "ingrese una fecha de salida", input: this.inputInicial },
        { campo: "ffinal", mensaje: "ingrese una fecha de regreso", input: this.inputFinal },
        { campo: "objeto", mensaje: "seleccione un objeto de contrato", input: this.inputObjeto },
        { campo: "viaje", mensaje: "seleccione un tipo de viaje", input: this.inputTipoViaje },
      ];

      // Solo validar origen y destino si NO es disponibilidad
      if (!this.isDisponilidad) {
        camposRequeridos.push(
          { campo: "origen", mensaje: "seleccione una ciudad de origen", input: this.inputOrigen },
          { campo: "destino", mensaje: "seleccione una ciudad de destino", input: this.inputDestino }
        );
      }

      for (const { campo, mensaje, input } of camposRequeridos) {
        const valor = this.formPlanilla.get(campo)?.value;
        if (valor === null || valor === undefined || (typeof valor === "string" && valor.trim() === "")) {
          this.mostrarAlerta("Campo requerido", `Por favor, ${mensaje}`, "info");
          input?.nativeElement?.focus?.();

          return;
        }
      }

      // 🔎 Validar campo disponibilidad si isDisponilidad es true
      if (this.isDisponilidad) {
        const disponibilidad = this.formPlanilla.get('disponibilidad')?.value;
        if (!disponibilidad || disponibilidad.trim() === '') {
          this.mostrarAlerta(
            "Campo requerido",
            "Por favor, ingrese la disponibilidad del vehículo",
            "info"
          );
          return;
        }
      }

      // 🔎 Validar si hay conductores
      if (!this.conductoresSeleccionados || this.conductoresSeleccionados.length === 0) {
        this.mostrarAlerta(
          "¡Importante!",
          "Por favor, seleccione al menos un conductor antes de continuar.",
          "info"
        );
        return;
      }

      // 🧠 Asignación de conductores (hasta 3)
      this.conductoresSeleccionados.forEach((c, index) => {
        const { conductor_id, nombre, licencia, vencimientoLicencia } = c;
        switch (index) {
          case 0:
            [this.cedula, this.conductor, this.licencia, this.vigencia] =
              [conductor_id, nombre, licencia, vencimientoLicencia];
            break;
          case 1:
            [this.cedula1, this.conductor1, this.licencia1, this.vigencia1] =
              [conductor_id, nombre, licencia, vencimientoLicencia];
            break;
          case 2:
            [this.cedula2, this.conductor2, this.licencia2, this.vigencia2] =
              [conductor_id, nombre, licencia, vencimientoLicencia];
            break;
        }
      });

      // 🧾 Recolectar datos del formulario
      const datosFormulario = this.formPlanilla.value;
      const raw = this.formPlanilla.getRawValue(); // incluye campos deshabilitados


      // 🧱 Armar objeto para el backend
      // Calcular fecha y hora actual de Colombia
      const fechaColombia = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Bogota' }); // 'YYYY-MM-DD'
      const horaColombia = new Date().toLocaleTimeString('en-GB', { timeZone: 'America/Bogota', hour12: false }); // 'HH:mm:ss'
      const fechahora = `${fechaColombia} ${horaColombia}`;

      // console.log(fechaColombia);
      // console.log(horaColombia);
      // console.log(fechahora);

    //  console.log(datosFormulario);

      const datos = {
        ...datosFormulario,
        objeto: raw.objeto,
        terceros: 0,
        ut: 0,
        conv: this.convenio,
        consor: 0,
        cedula: this.cedula,
        conductor: this.conductor,
        licencia: this.licencia,
        vigencia: this.vigencia,

        cedula1: this.cedula1,
        conductor1: this.conductor1,
        licencia1: this.licencia1,
        vigencia1: this.vigencia1,

        cedula2: this.cedula2,
        conductor2: this.conductor2,
        licencia2: this.licencia2,
        vigencia2: this.vigencia2,

        idresponsable: this.idReponsable,
        responsable: this.nombreResponsable,
        telefonor: this.telefonoResponsable,
        direccionr: this.direccionResponsable,
        nfuec: this.codigoUnificado,
        usuario: this.usuarioLogin?.usuario || this.usuarioLogin?.email || this.usuarioLogin?.username || 'desconocido',
        registro: fechaColombia,
        hora: horaColombia,
        fechahora: fechahora,

      };

    //  console.log("📤 Datos enviados:", datos);
  this.loadingService.mostrar(
      'Guardando...',
      [      
      ], "Enviando Fuec"
    );
      // 📩 Enviar al backend
      this.planillaService.createPlanilla(datos).subscribe({
        next: (response) => {
          console.log(response);
          const planillaCreada = response.Planilla;
          const idfuec = planillaCreada.idfuec;

         // console.log("🆔 ID del FUEC:", idfuec);
          if (idfuec) {
            //insertar los pasajeros asociados al FUEC
            this.pasajeros.forEach(pasajero => {
          //    console.log("Insertando pasajero:", pasajero);
              pasajero.extracto_id = idfuec;
              this.pasajerosService.crear(pasajero).subscribe({
                next: (response) => {
                  console.log("Pasajero insertado:", response);
                },
                error: (error) => {
                  console.error("Error insertando pasajero:", error);
                }
              });
            });
          this.loadingService.mostrar(
              'Guardando...',
              [
                {
                  id: 'enviando',
                  nombre: 'Guardando',
                  icono: '📝',
                  visible: true,
                  estado: 'completado'
                }, 
              ],
              "Guardando Fuec"
            );
            // Generar FUEC solo si se creó correctamente
            this.generarFuec(planillaCreada); // puedes pasar toda la info aquí
            this.mostrarAlerta2("Éxito", "FUEC creado correctamente", "success");
          }
          this.loadingService.ocultar();
          Swal.fire({
            icon: 'success',
            title: 'Registro guardado',
            text: 'El registro fue creado y el PDF está listo.',
            timer: 3000,
            showConfirmButton: false,
          });

          // Limpiar formulario después de guardar exitosamente
          this.limpiarFormulario();

        },
        error: (error) => {
          this.mostrarAlerta2("Error", error?.message || "Error al guardar el Extracto", "error");
        }
      });
    }

    
  }

  limpiarFormulario(): void {
   // console.log('🔄 Iniciando limpiarFormulario()...');
    
    // Reset del formulario principal con valores explícitos null
    this.formPlanilla.reset({
      empresa: null,
      contrato: null,
      finicial: null,
      ffinal: null,
      objeto: null,
      viaje: null,
      origen: null,
      destino: null,
      disponibilidad: null,
      complemento: null,
      ruta: null,
      terceros: false,
      ut: false,
      conv: false,
      consor: false
    });

    //this.pasajeros = [];
    this.conductoresSeleccionados = [];
    this.conductores.forEach(conductor => {
      conductor.seleccionado = false;
    });
    this.conductores = [];
    this.opcionSeleccionada = null;
    
    // Forzar limpieza de errores y estados de validación en cada control
    Object.keys(this.formPlanilla.controls).forEach(key => {
      const control = this.formPlanilla.get(key);
      if (control) {
        control.setErrors(null);
        control.markAsUntouched();
        control.markAsPristine();
      }
    });
    
    // Limpiar conductores seleccionados
    this.conductoresSeleccionados = [];
    
    // Resetear conductoresForm
    this.conductoresForm = [
      {
        conductorSeleccionado: null,
        cedula: "",
        licencia: "",
        vencelic: "",
        fechacobeps: "",
      },
    ];
    
    // Resetear visibilidad de conductores
    this.visibleConductores = [true, false, false];
    
    // Limpiar variables de conductores
this.cedula = this.conductor = this.licencia = this.vigencia = null;
this.cedula1 = this.conductor1 = this.licencia1 = this.vigencia1 = null;
this.cedula2 = this.conductor2 = this.licencia2 = this.vigencia2 = null;
/* 
this.cedula = null;
    this.conductor = null;
    this.licencia = null;
    this.vigencia = null;
    
    this.cedula1 = null;
    this.conductor1 = null;
    this.licencia1 = null;
    this.vigencia1 = null;
    
    this.cedula2 = null;
    this.conductor2 = null;
    this.licencia2 = null;
    this.vigencia2 = null; */
    
    // Limpiar datos del responsable
    this.idReponsable = null;
    this.nombreResponsable = null;
    this.telefonoResponsable = null;
    this.direccionResponsable = null;
    
    // Limpiar vehículo seleccionado
    this.vehiculoSeleccionado = null;
    this.placaSeleccionada = null;
    
    // Limpiar datos del vehículo
    this.placa = "";
    this.modelo = "";
    this.marca = "";
    this.tipos = "";
    this.interno = "";
    this.numero_tarjeta = "";
    
    // Limpiar código unificado
    this.codigoUnificado = "";
    
    // Limpiar empresa y contratos
    this.empresaSeleccionada = null;
    this.empresa = null;
    this.numeroContratos = [];
    this.contratoMostrado = null;
    this.contratoSeleccionado = null;
    this.contratoBuscado = false;
    
    // Resetear flags de estado
    this.isContratos = false;
    this.isResponsable = false;
    this.isDisponilidad = false;
    this.disponibilidadActiva = false;
    this.isEnableFuec = true;
    
    // Limpiar fechas máximas y mínimas
    this.fechaMaximaSalida = null;
    this.fechaMinimaSalida = '';
    this.fechaMinimaRegreso = this.fechaHoy;
    this.fechaMinimaFinal = '';
    
    // Reiniciar validación
    this.validate = false;
    
    // Resetear convenio
    this.convenio = 0;
    
    console.log('✅ Formulario reseteado completamente:', {
      formPlanilla: this.formPlanilla.value,
      conductoresSeleccionados: this.conductoresSeleccionados,
      conductoresForm: this.conductoresForm,
      visibleConductores: this.visibleConductores,
      vehiculoSeleccionado: this.vehiculoSeleccionado,
      placaSeleccionada: this.placaSeleccionada,
      codigoUnificado: this.codigoUnificado,
      empresaSeleccionada: this.empresaSeleccionada,
      isDisponilidad: this.isDisponilidad,
      validate: this.validate
    });
  }

  formatDate(fecha: string | Date | null): string {
    if (!fecha) return "";
    const date = new Date(fecha);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  formatDateForInput(date: Date | string): string {
    let d: Date;

    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date; // Ya viene listo
    }

    d = new Date(date);
    // Use UTC to avoid timezone issues
    const year = d.getUTCFullYear();
    const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    const day = ('0' + d.getUTCDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

    // Formatea fecha ISO a DD/MM/YYYY en Colombia (GMT-5) sin perder el día por conversión de zona horaria
formatoFechaColombia(fechaIso: string): string {
  if (!fechaIso) return '';
  // Parse as UTC
  const date = new Date(fechaIso);
  // Colombia offset: -5 hours
  const colombiaOffsetMs = -5 * 60 * 60 * 1000;
  // Ajustar a Colombia sumando el offset
  const colombiaDate = new Date(date.getTime() + colombiaOffsetMs);
  const dd = String(colombiaDate.getUTCDate()).padStart(2, '0');
  const mm = String(colombiaDate.getUTCMonth() + 1).padStart(2, '0');
  const yyyy = colombiaDate.getUTCFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

  actualizarMinFechaRegreso(fechaInicial: string): void {
    if (fechaInicial) {
      const fecha = new Date(fechaInicial);
      fecha.setDate(fecha.getDate() + 1); // Regreso debe ser al menos un día después
      this.fechaMinimaRegreso = this.formatDateForInput(fecha);
    } else {
      this.fechaMinimaRegreso = this.fechaHoy;
    }
  }



  actualizarNombreRuta(): void {
    const origenId = this.rutaForm.get("origen")?.value;
    const destinoId = this.rutaForm.get("destino")?.value;

    const origenNombre =
      this.municipios.find((m) => m.IDMUN === origenId)?.MUNICIPIO || "";
    const destinoNombre =
      this.municipios.find((m) => m.IDMUN === destinoId)?.MUNICIPIO || "";

    if (origenNombre && destinoNombre) {
      this.rutaForm.patchValue({
        nombre: `${origenNombre} - ${destinoNombre}`,
      });
    } else {
      this.rutaForm.patchValue({ nombre: "" });
    }
  }

  openModal(content: any, id?: number): void {
    if (id) {
      // Lógica de edición (si es necesario)
    } else {
      this.rutaSeleccionada = null;
      this.rutaForm.reset({ estado: true });
      this.modalService.open(content, { size: "xl", backdrop: "static" });
    }
  }
  // Guardar nueva ruta
  guardarRuta(): void {
    if (this.rutaForm.invalid) {
      this.mostrarAlerta(
        "Campo requerido",
        "Por favor, complete todos los campos correctamente.",
        "info"
      );
      this.rutaForm.markAllAsTouched();
      this.inputOrigen?.nativeElement.focus();
      return;
    }

    const datosRuta = {
      ...this.rutaForm.value,
      usuario: this.usuarioLogin,
    };

    if (this.editMode && this.rutaSeleccionada) {
      const sinCambios = this.esIgual(this.rutaSeleccionada, datosRuta);

      if (sinCambios) {
        this.mostrarAlerta(
          "Sin cambios",
          "No se han realizado modificaciones en la ruta.",
          "info"
        );
        return;
      }

      // TODO: lógica para actualizar la ruta (updateRuta)
      return;
    }

    // Crear nueva ruta
    this.rutasService.createRuta(datosRuta).subscribe({
      next: () => {
        this.mostrarExito("Guardado exitoso", "Ruta creada correctamente.");
        this.rutaForm.reset({ ruta: null, estado: true });
        this.cargarRutas();
        this.finalizarGuardado();
      },
      error: (err) => this.mostrarError(err, "Error al guardar la ruta"),
    });
  }

  private esIgual(a: any, b: any): boolean {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  private finalizarGuardado(): void {
    this.cerrarModalYRecargar();
  }

  private cerrarModalYRecargar() {
    this.modalService.dismissAll(); // Cierra el modal
  }

  private mostrarError(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  mostrarExito(titulo: string, mensaje: string): void {
    Swal.fire({ icon: "success", title: titulo, text: mensaje });
    this.cerrarModalYRecargar();
  }

  getClaseTextoVigencia(index: number): string {
    const campo = "vigencia" + (index === 0 ? "" : index);
    const fecha = this.formPlanilla.get(campo)?.value;
    return this.convertirEstadoEnClase(this.getEstadoLicencia(fecha));
  }

  getClaseTextoSeguSocial(index: number): string {
    const campo = "fechacobeps" + (index === 0 ? "" : index);
    const fecha = this.formPlanilla.get(campo)?.value;
    return this.convertirEstadoEnClase(this.getEstadoLicencia(fecha));
  }

  convertirEstadoEnClase(estado: string): string {
    switch (estado) {
      case "VIGENTE":
        return "text-success";
      case "POR VENCER":
        return "text-warning";
      case "VENCIDO":
        return "text-danger";
      default:
        return "text-primary";
    }
  }

  getEstadoLicencia(fechaStr: string | undefined): string {
    if (!fechaStr) return "SIN FECHA";

    const hoy = new Date();
    const vencelic = new Date(fechaStr);
    const diffDias = (vencelic.getTime() - hoy.getTime()) / (1000 * 3600 * 24);

    if (diffDias < 0) return "VENCIDO";
    if (diffDias <= 30) return "POR VENCER";
    return "VIGENTE";
  }

  getClasePorCampo(index: number, campoBase: string): string {
    const campo = campoBase + (index === 0 ? "" : index);
    const fecha = this.formPlanilla.get(campo)?.value;
    const estado = this.getEstadoLicencia(fecha);
    return this.convertirEstadoEnClase(estado);
  }

  seleccionarConductor(conductor: any, index: number): void {
    const estadoLicencia =
      conductor.propietario?.estado_vencelic?.toLowerCase();
    const estadoCobeps =
      conductor.propietario?.estado_fechacobeps?.toLowerCase();

    const tieneVencido =
      estadoLicencia === "vencida" ||
      estadoLicencia === "vencido" ||
      estadoCobeps === "vencida" ||
      estadoCobeps === "vencido";

    if (tieneVencido) {
      // Mostrar mensaje de advertencia
      this.mostrarMensajeError(
        "No puedes seleccionar este conductor, tiene fechas vencidas"
      );

      // Deseleccionar el conductor (ejemplo: limpiar el formControl o variable)
      this.formPlanilla.get("conductor" + (index === 0 ? "" : index))?.reset();
      return;
    }

    // Si pasa la validación, puedes continuar con la asignación
    console.log("Conductor seleccionado correctamente:", conductor);
  }

  mostrarMensajeError(mensaje: string): void {
    // Si usas SweetAlert2
    Swal.fire({
      icon: "error",
      title: "Conductor inválido",
      text: mensaje,
    });

    // Si prefieres un alert nativo
    // alert(mensaje);
  }

  actualizarMinFechaFinal(): void {
    const inicio = this.formContrato.get("inicio")?.value;

    if (inicio) {
      const fecha = new Date(inicio);
      fecha.setDate(fecha.getDate() + 1); // mínimo un día después
      this.fechaMinimaFinal = this.formatDateForInput(fecha);

      const fin = this.formContrato.get("fin")?.value;
      if (fin && new Date(fin) <= new Date(inicio)) {
        this.formContrato.get("fin")?.setValue(null);
      }
    } else {
      const hoy = new Date();
      this.fechaMinimaFinal = this.formatDateForInput(hoy);

      const fin = this.formContrato.get("fin")?.value;
      if (fin && new Date(fin) < hoy) {
        this.formContrato.get("fin")?.setValue(null);
      }
    }
  }

  soloNumeros(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, "").slice(0, 10);
    this.rutaForm.get("telefonor")?.setValue(input.value);
  }


  customSearchFn(term: string, item: any): boolean {
    term = term.toLowerCase();
    return item.nombre.toLowerCase().includes(term) || item.nit.toLowerCase().includes(term);
  }

  preventInput(event: Event): void {
    event.preventDefault();
  }


  //VALIDA LA FECHA MAXIMA DEL CONTRATO Y LOS DOCUMENTOS DEL VEHICULO
  getFechaMenor(fecha1: string | Date, fecha2: string | Date): string {
    const parseLocalDate = (input: string | Date): Date => {
      if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
        const [year, month, day] = input.split('-').map(Number);
        return new Date(year, month - 1, day); // 👈 evita UTC
      }
      return new Date(input);
    };

    const f1 = parseLocalDate(fecha1);
    const f2 = parseLocalDate(fecha2);
    const menor = f1 < f2 ? f1 : f2;

    return this.formatDateForInput(menor);
  }

opciones = [
  { valor: 'AFILIADO', label: 'AFILIADO' },
  { valor: 'CONVENIOS', label: 'CONVENIO' },
  { valor: 'CONSORCIO', label: 'CONSORCIO' },
  { valor: 'UNION TEMPORAL', label: 'UNIÓN TEMPORAL' }
];

esConductorVigente(conductor: any): boolean {
  const vencelic = conductor.propietario?.vencelic;
  const fechacobeps = conductor.propietario?.fechacobeps;

  if (!vencelic || !fechacobeps) {
    // Si alguna de las fechas está ausente, no es válido
    return false;
  }

  const hoy = new Date();
  const vencLicDate = new Date(vencelic);
  const fechArlDate = new Date(fechacobeps);

  return vencLicDate >= hoy && fechArlDate >= hoy;
}
maxSeleccionados = 3;




toggleSeleccion(conductor: any, event: Event): void {
  const input = event.target as HTMLInputElement;
  const isChecked = input.checked;

  const conductorId = conductor.conductor_id;

  // Verificar si ya está seleccionado en la lista principal
  const yaSeleccionado = this.conductoresSeleccionados.some(
    c => c.conductor_id === conductorId
  );

  // Si se está desmarcando, permitirlo siempre
  if (!isChecked) {
    conductor.seleccionado = false;

    this.conductoresSeleccionados =
      this.conductoresSeleccionados.filter(
        c => c.conductor_id !== conductorId
      );

    return;
  }

  // Evitar registros duplicados
  if (yaSeleccionado) {
    conductor.seleccionado = true;
    return;
  }

  // Validar licencia y ARL
  const fechaLicencia = conductor.propietario?.vencelic;
  const fechaArl = conductor.propietario?.fechacobeps;

  const licenciaVencida = this.isFechaVencida(fechaLicencia);
  const arlVencida = this.isFechaVencida(fechaArl);

  if (licenciaVencida || arlVencida) {
    input.checked = false;
    conductor.seleccionado = false;

    const documentosVencidos: string[] = [];

    if (licenciaVencida) {
      documentosVencidos.push('licencia de conducción');
    }

    if (arlVencida) {
      documentosVencidos.push('ARL');
    }

    Swal.fire({
      icon: 'error',
      title: 'Conductor inválido',
      text: `No se puede seleccionar: tiene vencido(s) ${documentosVencidos.join(' y ')}.`,
      confirmButtonColor: '#0d6efd',
      confirmButtonText: 'Aceptar'
    });

    return;
  }

  // Validar límite máximo
  if (
    this.conductoresSeleccionados.length >= this.maxSeleccionados
  ) {
    input.checked = false;
    conductor.seleccionado = false;

    Swal.fire({
      icon: 'warning',
      title: 'Límite alcanzado',
      text: `Solo puedes seleccionar hasta ${this.maxSeleccionados} conductores.`,
      confirmButtonColor: '#0d6efd',
      confirmButtonText: 'Aceptar'
    });

    return;
  }

  // Crear objeto del conductor
  const objConductor = {
    conductor_id: conductorId,
    nombre: [
      conductor.propietario?.primernombre,
      conductor.propietario?.segundonombre,
      conductor.propietario?.papellidos,
      conductor.propietario?.seapellidos
    ]
      .filter(nombre => nombre?.trim())
      .join(' '),

    licencia: conductor.propietario?.numerolic || '',
    vencimientoLicencia: fechaLicencia || null,
    arl: fechaArl || null
  };

  // Actualizar ambas listas
  conductor.seleccionado = true;
  this.conductoresSeleccionados.push(objConductor);

  console.log('Seleccionados:', this.conductoresSeleccionados);
}




isFechaVencida(fecha: string | Date | null): boolean {
  if (!fecha) return true; // Considera sin fecha como vencido

  const hoy = new Date();
  const fechaComparar = new Date(fecha);

  // Quitar la hora para una comparación más precisa por día
  hoy.setHours(0, 0, 0, 0);
  fechaComparar.setHours(0, 0, 0, 0);

  return fechaComparar < hoy;
}
  async addHeaderImages(
    doc: jsPDF,
    gpcGoogle: any,
    imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number }>,
    fallbackPath: string
  ) {
    // Obtener URL firmada de forma segura
    const getSignedUrlSafe = async (path: string) => {
      try {
        const res = await gpcGoogle.getSignedUrl(path).toPromise();
        return res?.url || null;
      } catch {
        return null;
      }
    };

    // Obtener imagen en base64, con fallback
    const getBase64WithFallback = async (url: string | null, fallbackPath: string) => {
      if (url) {
        try {
          return await gpcGoogle.getImageBase64(url);
        } catch {
          // fallback
        }
      }
      return await gpcGoogle.getImageBase64(fallbackPath);
    };

    // Comprimir base64 usando canvas
    const compressBase64Image = async (base64: string, quality = 0.1): Promise<string> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          if (!ctx) return reject("No canvas context");
          ctx.drawImage(img, 0, 0);
          const compressed = canvas.toDataURL("image/png", quality); // quality 0–1
          resolve(compressed);
        };
        img.onerror = reject;
        img.src = base64;
      });
    };

    // 1. Obtener las claves y rutas
    const imageEntries = Object.entries(imageMap);

    // 2. Obtener URLs firmadas
    const signedUrls = await Promise.all(
      imageEntries.map(([_, img]) => getSignedUrlSafe(img.path))
    );

    // 3. Obtener y comprimir Base64
    const base64Images = await Promise.all(
      signedUrls.map(async (url, index) => {
        const base64 = await getBase64WithFallback(url, fallbackPath);
        return base64 ? await compressBase64Image(base64, 0.6) : null; // puedes ajustar el 0.6
      })
    );

    // 4. Agregar imágenes al PDF
    base64Images.forEach((base64, idx) => {
      if (base64) {
        const { x, y, w, h } = imageEntries[idx][1];
        doc.addImage(base64, "JPEG", x, y, w, h, undefined, "FAST");
      }
    });
  }
async generarFuec(planilla: any) {
  const doc = new jsPDF();
  //console.log("🧾 Generando FUEC con:", planilla);
   await this.addHeaderImages(doc, this.gpcGoogle, {
      supertransporte: { path: "ministerio/supertransporte.png", x: 105, y: 20, w: 50, h: 16 },
      minsupertransporte: { path: "ministerio/mintransporte.png", x: 55, y: 20, w: 50, h: 16 },
      potencia: { path: "ministerio/potencia.png", x: 10, y: 21, w: 40, h: 16 },
      logo: { path: `${this.administraciones[0].nit}/logos/logo.png`, x: this.posicionX, y: this.posicionY, w: this.ancho, h: this.altura },
   
    }, "../../../../../assets/images/hoja_vida/sinfoto.png");
  // Puedes acceder a todo el contenido
 
  const clase = planilla.clase;
   // === MARCA DE AGUA (de fondo) ===
const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();
// Opcional: Guardar estilos actuales
doc.saveGraphicsState();
doc.setFont('helvetica', 'normal');
doc.setFontSize(100);
doc.setTextColor(232, 232, 232); // Gris claro
doc.text('ORIGINAL', pageWidth / 2, pageHeight / 2, {
  align: 'center',
  angle: 0
});

doc.restoreGraphicsState();
  // Encabezado
  doc.setFontSize(12);
  doc.text('FICHA TÉCNICA DEL FORMATO ÚNICO DEL EXTRACTO DEL CONTRATO - FUEC', 105, 15, { align: 'center' });
  
  // Datos del contrato 
  doc.setFontSize(11);
  let y = 45;
  
  doc.setFont("helvetica","bold");
  doc.text('FORMATO ÚNICO DE EXTRACTO DEL CONTRATO DEL SERVICIO PÚBLICO DE', 105, y,{ align: 'center' });
   y += 5;
  doc.text('TRANSPORTE TERRESTRE AUTOMOTOR ESPECIAL', 105, y,{ align: 'center' });
  y += 5;
  const contratoFormateado1 = String(planilla.contrato).padStart(4, '0')
  const idfuecFormateado = String(planilla.idfuec).padStart(4, '0')
  doc.text('No '+ planilla.nfuec +contratoFormateado1+idfuecFormateado, 105, y,{ align: 'center' });
  


  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');

    y += 10;
  // Datos de la empresa
  doc.text('RAZÓN SOCIAL DE LA EMPRESA DE TRANSPORTE ESPECIAL:', 10, y);
  doc.text(planilla.infoEmpresa.empresa, 98, y);
   y += 5;
  doc.text('NIT:', 10, y);
  doc.text(planilla.nite, 60, y);


  // Datos del contrato
   y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('CONTRATO No.:', 10, y);
  doc.setFont('helvetica', 'normal');
  const contratoFormateado = planilla.contrato.toString().padStart(4, '0');
  doc.text(contratoFormateado, 60, y);
  

  y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('CONTRATANTE:', 10, y);
  doc.setFont('helvetica', 'normal');
  
  doc.text(planilla.nitc, 60, y);

  y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('NIT/CC:', 10, y);
  doc.setFont('helvetica', 'normal');
  doc.text(planilla.empresa, 60, y);

  // Objeto
   y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('OBJETO DEL CONTRATO:', 10,y);
  doc.setFont('helvetica', 'normal');
  doc.text(planilla.descripcionObjeto.descripcion, 60,y);
  
    if (planilla.complemento) {
    y += 3;
    doc.setFontSize(7); // Reducir tamaño de fuente para disponibilidad
    const maxWidth = 140; // Ancho máximo para el texto
    const textLines = doc.splitTextToSize(planilla.complemento, maxWidth);
    doc.text(textLines, 60, y);
    // Ajustar Y según la cantidad de líneas del complemento
    y += (textLines.length - 1) * 4;
   }
  // ORIGEN DESTION VIAJE
   y += 5;
    doc.setFontSize(8); // Reducir tamaño de fuente para disponibilidad
  doc.setFont('helvetica', 'bold');
  doc.text('ORIGEN - DESTINO:', 10,y);
  doc.setFont('helvetica', 'normal');
  
  if (planilla.disponibilidad) {
    doc.setFontSize(7); // Reducir tamaño de fuente para disponibilidad
    const maxWidth = 140; // Ancho máximo para el texto
    const textLines = doc.splitTextToSize('DISPONIBILIDAD TOTAL:' + planilla.disponibilidad + " " + planilla.descripcionViaje.descripcion, maxWidth);
    doc.text(textLines, 60, y);
    // Ajustar Y según la cantidad de líneas (cada línea ocupa ~4 unidades con fuente más pequeña)
    y += (textLines.length - 1) * 4;
    doc.setFontSize(8); // Restaurar tamaño de fuente
  } else {
      doc.setFontSize(8);
    const maxWidth = 150; // Ancho máximo para el texto
    const textLines = doc.splitTextToSize(planilla.origen + ' - ' + planilla.destino + " " + planilla.descripcionViaje.descripcion, maxWidth);
    doc.text(textLines, 60, y);
    // Ajustar Y según la cantidad de líneas
    y += (textLines.length - 1) * 4;
    doc.setFontSize(8);
  }

  // ORIGEN DESTION VIAJE
   y += 5;
   if(planilla.conv && planilla.conv!=""){
    doc.setFont('helvetica', 'bold');
    doc.text('CONVENIO DE COLABORACIÓN:', 10,y);
    doc.setFont('helvetica', 'normal');
    doc.text( planilla.vehiculo.nombreEmpresa.nombre, 60,y);
   }else{
     doc.setFont('helvetica', 'bold');
    doc.text('CONVENIO DE COLABORACIÓN:', 10,y);
    doc.setFont('helvetica', 'normal');
    doc.text( "-", 60,y);
   }
  
  
     y += 10;
   doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('VIGENCIA DEL CONTRATO', 105, y,{ align: 'center' });

  // Estilos de fondo y bordes
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(12);
 y += 2;
// Coordenadas y anchos de columnas
const x1 = 10;
const w1 = 92;

const x2 = x1 + w1;   // 105
const w2 = 30;
const w3 = 30;
const w4 = 30;

// Dibujar celdas
doc.rect(x1, y, w1, 10, 'S');             // FECHA INICIAL
doc.rect(x2, y, w2, 10, 'S');             // DÍA
doc.rect(x2 + w2, y, w3, 10, 'S');        // MES
doc.rect(x2 + w2 + w3, y, w4, 10, 'S');   // AÑO



const fecha = new Date(planilla.finicial);
const dia = String(fecha.getUTCDate()).padStart(2, '0');
const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
const anio = String(fecha.getUTCFullYear());


// Escribir texto centrado
doc.setFont('helvetica', 'normal');
doc.text("FECHA INICIAL", x1 + 2, y + 7); // alineado a la izquierda (2px de margen)
doc.setFont('helvetica', 'bold');
doc.text("DÍA", x2 + w2 / 2, y + 4.5, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.text(dia, x2 + w2 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("MES", x2 + w2 + w3 / 2, y + 4.5, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.text(mes, x2 + w2 + w3 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("AÑO", x2 + w2 + w3 + w4 / 2, y + 4.5, { align: 'center' })
doc.setFont('helvetica', 'normal');
doc.text(anio, x2 + w2 + w3 + w4 / 2, y + 9, { align: 'center' });

  y += 2;
     

   // Estilos de fondo y bordes
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(12);
 y += 8;



// Dibujar celdas
doc.rect(x1, y, w1, 10, 'S');             // FECHA INICIAL
doc.rect(x2, y, w2, 10, 'S');             // DÍA
doc.rect(x2 + w2, y, w3, 10, 'S');        // MES
doc.rect(x2 + w2 + w3, y, w4, 10, 'S');   // AÑO

const fecha2 = new Date(planilla.ffinal);
const dia2 = String(fecha2.getUTCDate()).padStart(2, '0');
const mes2 = String(fecha2.getUTCMonth() + 1).padStart(2, '0');
const anio2 = String(fecha2.getUTCFullYear());

// Escribir texto centrado
doc.text("FECHA VENCIMIENTO", x1 + 2, y + 7); // alineado a la izquierda (2px de margen)
doc.text("DÍA", x2 + w2 / 2, y + 4.5, { align: 'center' });
doc.text(dia2, x2 + w2 / 2, y + 9, { align: 'center' });

doc.text("MES", x2 + w2 + w3 / 2, y + 4.5, { align: 'center' });
doc.text(mes2, x2 + w2 + w3 / 2, y + 9, { align: 'center' });
doc.text("AÑO", x2 + w2 + w3 + w4 / 2, y + 4.5, { align: 'center' })
doc.text(anio2, x2 + w2 + w3 + w4 / 2, y + 9, { align: 'center' });

 
  y += 20;
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('CARACTERÍSTICA DEL VEHÍCULO', 105, y,{ align: 'center' });
  y += 2;

 
     

   // Estilos de fondo y bordes
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(12);



const x11 = 10;

// Anchos de columnas
const w11 = 45; // PLACA
const w22 = 46; // MODELO
const w33 = 45; // MARCA
const w44 = 46; // CLASE

// Dibujar celdas
doc.rect(x11, y, w11, 10, 'S');                   // PLACA
doc.rect(x11 + w11, y, w22, 10, 'S');              // MODELO
doc.rect(x11 + w11 + w22, y, w33, 10, 'S');         // MARCA
doc.rect(x11 + w11 + w22 + w33, y, w44, 10, 'S');    // CLASE

// Escribir texto centrado en cada celda (horizontal y vertical)
const yText = y + 6; // Centrado verticalmente (ajustable)

doc.text("PLACA", x11 + w11 / 2, yText, { align: 'center' });
doc.text("MODELO", x11 + w11 + w22 / 2, yText, { align: 'center' });
doc.text("MARCA", x11 + w11 + w22 + w33 / 2, yText, { align: 'center' });
doc.text("CLASE", x11 + w11 + w22 + w33 + w44 / 2, yText, { align: 'center' });
 y += 10;
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);

// Dibujar celdas
doc.rect(x11, y, w11, 10, 'S');                   // PLACA
doc.rect(x11 + w11, y, w22, 10, 'S');              // MODELO
doc.rect(x11 + w11 + w22, y, w33, 10, 'S');         // MARCA
doc.rect(x11 + w11 + w22 + w33, y, w44, 10, 'S');    // CLASE
 doc.setFont('helvetica', 'normal');
 doc.text(planilla.placa, x11 + w11 / 2, y + 6, { align: 'center' }); //PLACA

const modeloStr = planilla.modelo ? String(planilla.modelo) : '';
doc.text(modeloStr, x11 + w11 + w22 / 2, y + 6, { align: 'center' }); //MODELO

doc.text(planilla.marca, x11 + w11 + w22 + w33 / 2, y + 6, { align: 'center' }); //MARCA
doc.text(clase, x11 + w11 + w22 + w33 + w44 / 2, y + 6, { align: 'center' }); //CLASE

//interno
 y += 10; // Moverse a la siguiente fila

const x111 = 10;
const w111 = 45;
const h = 10;

doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);

doc.setFont('helvetica', 'bold');
// Celda 1: INTERNO
doc.rect(x111, y, w111 + 46, h, 'S');
doc.text("NÚMERO INTERNO", x111 + (w111 + 46) / 2, y + 6, { align: 'center' });

doc.setFillColor(255, 255, 255); // fondo blanco
doc.setTextColor(0, 0, 0);       // texto negro
doc.setDrawColor(0);            // bordes negros

// Celda 1: INTERNO
doc.rect(x111+91, y, w111 + 46, h, 'S');
doc.text("TARJETA DE OPERACIÓN", x111 +91+ (w111 + 46) / 2, y + 6, { align: 'center' });


doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);
// ↓↓↓ NUEVA FILA DE VALORES DEBAJO ↓↓↓
y += h;

// Valor debajo de NÚMERO INTERNO
doc.rect(x111, y, w111 + 46, h, 'S');
doc.setFont('helvetica', 'normal');
const internoStr = planilla.interno ? String(planilla.interno) : '';
doc.text(internoStr, x111 + (w111 + 46) / 2, y + 6, { align: 'center' });


doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);
doc.setFont('helvetica', 'normal');
// Valor debajo de TARJETA DE OPERACIÓN
doc.rect(x111 + 91, y, w111 + 46, h, 'S');
const tarjetaStr = planilla.operaciones ? String(planilla.operaciones) : '';
doc.text(tarjetaStr, x111 + 91 + (w111 + 46) / 2, y + 6, { align: 'center' });


 y += 10; // Moverse a la siguiente fila

const h2 = 14;
const x112 = 10;
const w112 = 32;

doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
// Agregar texto dividido en dos líneas
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("CONDUCTOR No. 1", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');

if (!planilla.conductor || planilla.conductor.trim() === '') {
  planilla.conductor = "-";
}

if (!planilla.cedula || planilla.cedula.trim() === '') {
  planilla.cedula = "-";
}

if (!planilla.licencia || planilla.licencia.trim() === '') {
  planilla.licencia = "-";
}

doc.text(planilla.conductor, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.cedula, x112 + 105, y + 9, { align: 'center' });

const xText = x112 + 105 + 28; // posición X centrada para la columna
const yStart = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("NÚMERO LICENCIA", xText, yStart, { align: 'center' });
doc.text("CONDUCCIÓN", xText, yStart + 4, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.licencia, xText, yStart + 8, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("VIGENCIA", xText+30, yStart, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);

if(planilla.vigencia){
const fechaOriginal = planilla.vigencia;
const fecha1 = new Date(fechaOriginal);

const fechaFormateada = fecha1.toLocaleDateString('es-CO', {
  timeZone: 'UTC',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});
doc.text(fechaFormateada, xText+30, yStart + 8, { align: 'center' });
}else{
  doc.text("-", xText+30, yStart + 8, { align: 'center' });
}






y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("CONDUCTOR No. 2", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');

if (!planilla.conductor1 || planilla.conductor1.trim() === '') {
  planilla.conductor1 = "-";
}

if (!planilla.cedula1 || planilla.cedula1.trim() === '') {
  planilla.cedula1 = "-";
}

if (!planilla.licencia1 || planilla.licencia1.trim() === '') {
  planilla.licencia1 = "-";
}



doc.text(planilla.conductor1, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');

doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.cedula1, x112 + 105, y + 9, { align: 'center' });

const xText1 = x112 + 105 + 28; // posición X centrada para la columna
const yStart1 = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("NÚMERO LICENCIA", xText1, yStart1, { align: 'center' });
doc.text("CONDUCCIÓN", xText1, yStart1 + 4, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.setFontSize(8);
doc.text(planilla.licencia1, xText1, yStart1 + 8, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("VIGENCIA", xText1+30, yStart1, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);

if(planilla.vigencia1){
const fechaOriginal22 = planilla.vigencia1;
const fecha221 = new Date(fechaOriginal22);

const fechaFormateada22 = fecha221.toLocaleDateString('es-CO', {
  timeZone: 'UTC',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});
doc.text(fechaFormateada22, xText1+30, yStart1 + 8, { align: 'center' });
}else{
  doc.text("-", xText1+30, yStart1 + 8, { align: 'center' });
}






y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("CONDUCTOR No. 3", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
if (!planilla.conductor2 || planilla.conductor2.trim() === '') {
  planilla.conductor2 = "-";
}

if (!planilla.cedula2 || planilla.cedula2.trim() === '') {
  planilla.cedula2 = "-";
}

if (!planilla.licencia2 || planilla.licencia2.trim() === '') {
  planilla.licencia2 = "-";
}



doc.text(planilla.conductor2, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(8);
doc.setFontSize(10);
doc.text(planilla.cedula2, x112 + 105, y + 9, { align: 'center' });

const xText11 = x112 + 105 + 28; // posición X centrada para la columna
const yStart11 = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("NÚMERO LICENCIA", xText11, yStart11, { align: 'center' });
doc.text("CONDUCCIÓN", xText11, yStart11 + 4, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.licencia2, xText11, yStart11 + 8, { align: 'center' });

if(planilla.vigencia2){
const fechaOriginal2 = planilla.vigencia2;
const fecha22 = new Date(fechaOriginal2);

const fechaFormateada2 = fecha22.toLocaleDateString('es-CO', {
  timeZone: 'UTC',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});

//console.log(fechaFormateada2); // "07/03/2026"
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("VIGENCIA", xText11+30, yStart11, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(fechaFormateada2, xText11+30, yStart11 + 8, { align: 'center' });
}else{
  doc.text("-", xText11+30, yStart11 + 8, { align: 'center' });
}



y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("RESPONSABLE", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.text(planilla.responsable, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.text(planilla.idresponsable, x112 + 105, y + 9, { align: 'center' });

const xText111 = x112 + 105 + 28; // posición X centrada para la columna
const yStart111 = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("TELÉFONO", xText111, yStart111, { align: 'center' });


doc.setFont('helvetica', 'normal');
doc.setFontSize(8);
const telefonorStr = planilla.telefonor ? String(planilla.telefonor) : '';
doc.text(telefonorStr, xText111, yStart111 + 5, { align: 'center' });

const textDireccion = planilla.direccionr || '';
const maxWidth = 40; // ajusta al ancho máximo que quieras
const textLines = doc.splitTextToSize(textDireccion, maxWidth);

doc.setFont('helvetica', 'bold');
doc.text("DIRECCIÓN", xText111 + 30, yStart111, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.text(textLines, xText111 + 30, yStart111 + 3, { align: 'center' });

y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112+59, h2+20, 'S');
doc.rect(x112+91, y, w112+59, h2+20, 'S');
doc.setFont('helvetica', 'normal');
y += 5;
doc.setFontSize(10);
doc.text(planilla.infoEmpresa.direccion, 12,y);

y += 5; // Moverse a la siguiente fila
const telefonoStr =planilla.infoEmpresa.telefono ? String(planilla.infoEmpresa.telefono) : '';
doc.text(telefonoStr, 12,y);
y += 5; // Moverse a la siguiente fila
doc.text(planilla.infoEmpresa.email, 12,y);
y += 5; // Moverse a la siguiente fila
doc.text(planilla.infoEmpresa.web, 12,y);

if (this.administraciones.length > 0) {
  const firmaPath = this.administraciones[0].nit + "/logos/firma.png";
  try {
    const firmaUrl = await this.gpcGoogle.getSignedUrl(firmaPath).toPromise();
    if (firmaUrl?.url) {
      // Intentar obtener la imagen, solo agregar si existe
      try {
        const firmaBase64 = await this.gpcGoogle.getImageBase64(firmaUrl.url);
        if (firmaBase64) {
          doc.addImage(firmaBase64, "PNG", 115, y-10, 60, 15);
        }
      } catch (e) {
        // No agregar imagen si no existe
      }
    }
  } catch (e) {
    // No agregar imagen si no existe
  }
}
  doc.setFontSize(10);
  doc.text("FIRMA GERENTE EMPRESA", 125, y + 10);
  
  // Registro de fecha y hora en posición fija vertical con formato dd/mm/aa
  doc.setFontSize(8);
  const fechaRegistro = new Date(planilla.registro);
  const diaReg = String(fechaRegistro.getUTCDate()).padStart(2, '0');
  const mesReg = String(fechaRegistro.getUTCMonth() + 1).padStart(2, '0');
  const anioReg = String(fechaRegistro.getUTCFullYear()).slice(-2);
  const textoRegistro = `${diaReg}/${mesReg}/${anioReg} ${planilla.hora}`;
  doc.text(textoRegistro, 195, 270, { angle: 90 });
  
  // Generar QR y posicionarlo de forma absolutamente fija
  const qrBase64 = await QRCode.toDataURL(environment.apiUrl + "/api/validar-fuec/"+ this.administraciones[0].consumidas+"/"+planilla.idfuec);
  
  // Posición fija en la parte inferior izquierda (sin depender de variables dinámicas)
  const qrX = 75;
  const qrY = 252; // Posición fija en el eje Y
  const qrSize = 20;
  
  doc.addImage(qrBase64, 'PNG', qrX, qrY, qrSize, qrSize);
   this.addFooter(doc, planilla.idfuec);

   //VALIDAR SI TENEMOS LISTADO DE PASAJEROS 
  try {
  
  

   if (this.pasajeros && this.pasajeros.length > 0) {
     // Lógica si hay pasajeros
     doc.addPage();
   //  doc.text("Listado de Pasajeros", 10, 10);
     this.generarListado(doc, this.pasajeros, planilla);
   }
  } catch (e) {
    console.error('Error obteniendo listado de pasajeros:', e);
  }

  // Abrir el PDF en nueva pestaña
  const blobUrl = doc.output('bloburl');
  window.open(blobUrl, '_blank');
}

 formatearFecha(fechaISO: string): string {
  const fecha = new Date(fechaISO);
  const dia = String(fecha.getUTCDate()).padStart(2, '0');
  const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0'); // Mes empieza en 0
  const anio = fecha.getUTCFullYear();

  return `${dia}/${mes}/${anio}`;
}

addFooter(doc: jsPDF,  id: string | number) {
  const pageWidth = doc.internal.pageSize.width;

  const now = new Date();
  const fecha = now.toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const hora = now.toLocaleTimeString("es-CO", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const fechaHora = `${fecha} ${hora}`;
  const idFormatted = String(id).padStart(4, '0'); // ejemplo: 0042

  doc.setFont("helvetica", "italic");
  doc.setFontSize(8);
  doc.setTextColor(100);

  // Posiciones fijas del footer
  const footerY1 = 291; // Posición fija para fecha/ID
  const footerY2 = 291; // Posición fija para texto central

  // 🕓 Izquierda: Fecha y hora
  doc.text(fechaHora, 10, footerY1);

  // 🏢 Centro: Texto con enlace
  doc.textWithLink(
    "Generado desde Admin SEAF – INDESOFT - ORIGINAL",
    pageWidth / 2,
    footerY2,
    {
      url: "https://indesoftsas.com",
      align: "center",
    }
  );

  // 📄 Derecha: ID + número de página
  doc.text(`ID: ${idFormatted} `, pageWidth - 10, footerY1, {
    align: "right",
  });
 //  this.mostrandoToast = false;
}

  mostrarEmpresaSeleccionada(): void {
    this.empresaMostrada =
      this.empresas.find((e) => e.nit === this.empresaSeleccionada) || null;

    this.contratoMostrado = null;
    this.contratoSeleccionado = null;
    console.log(this.empresaMostrada);
    if (this.esUsuarioTenant) { 
        //LLAMAR A LA FUNCION PARA CARGAR LOS OBJETOS DE CONTRATO PARA CADA USUARIO
        this.usuarioObjetosContratosService.getByUsuario(this.usuarioLogin?.id).subscribe({
          next: (data: any[]) => {
            // filtrar solo objetos habilitados para contratos
            this.objetos = data.filter((obj: any) => Number(obj.isContrato) === 1);
          },
          error: (err) => {
            console.error("Error al cargar contratista por usuario:", err);
          },
        });
      }
    if (this.empresaMostrada) {
      this.formContrato.patchValue({
        cedula: this.empresaMostrada.nit,
        contratante: this.empresaMostrada.nombre,
        direccion: this.empresaMostrada.direccion,
        ciudad: this.empresaMostrada.municipio.MUNICIPIO, // corregido
        telefono: this.empresaMostrada.celular,
        mail: this.empresaMostrada.email,
      });
    }
  }

    mostrarYDescargarPDF(doc: jsPDF, nombreArchivo: string = 'documento.pdf') {
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    // Abrir en nueva pestaña
    window.open(pdfUrl, '_blank');
    // Descargar automáticamente
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = nombreArchivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Opcional: liberar el objeto URL después de un tiempo
   setTimeout(() => {
    URL.revokeObjectURL(pdfUrl);
    // Recargar la página después de mostrar y descargar el PDF
    window.location.reload();
  }, 500);

  }

generarListado(pdf: jsPDF, pasajeros: any[] = this.pasajeros,extracto: any ): void {
  console.log('Generando listado de pasajeros...');

  // Filtrar únicamente pasajeros activos
  const pasajerosActivos = (pasajeros || [])
    .filter(pasajero => pasajero.estado === 'ACTIVO');

  if (pasajerosActivos.length === 0) {
    Swal.fire(
      'Sin pasajeros activos',
      'No hay pasajeros activos para generar el listado.',
      'info'
    );
    return;
  }

  // Configuración del documento

  const anchoPagina = pdf.internal.pageSize.getWidth();
  const altoPagina = pdf.internal.pageSize.getHeight();
  const margen = 14;


  const fechaActual = new Date();
  const fecha = fechaActual.toLocaleDateString('es-CO');
  const hora = fechaActual.toLocaleTimeString('es-CO', {
    hour: '2-digit',
    minute: '2-digit'
  });

  // Evitar valores nulos o vacíos
  const dato = (valor: unknown): string => {
    if (
      valor === null ||
      valor === undefined ||
      String(valor).trim() === ''
    ) {
      return 'SIN DATOS';
    }

    return String(valor).trim();
  };

  const origen = extracto?.origen?.trim() || '';
  const destino = extracto?.destino?.trim() || '';

  const ruta = origen || destino
    ? `${origen || 'SIN DATOS'} - ${destino || 'SIN DATOS'}`
    : 'SIN DATOS';

  // ==========================================
  // 1. ENCABEZADO CORPORATIVO
  // ==========================================

  pdf.setFillColor(82,82,82);
  pdf.rect(0, 0, anchoPagina, 8, 'F');

  pdf.setTextColor(55, 65, 81);
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(17);

/*   pdf.text(
    'ADMIN SEAF',
    anchoPagina / 2,
    19,
    { align: 'center' }
  );
 */
  pdf.setFontSize(12);

  pdf.text(
    'LISTADO DE PASAJEROS',
    anchoPagina / 2,
    19,
    { align: 'center' }
  );

  // Línea decorativa roja
  pdf.setDrawColor(61, 61,61);
  pdf.setLineWidth(0.8);

  pdf.line(
    margen,
    24,
    anchoPagina - margen,
    24
  );

  // ==========================================
  // 2. INFORMACIÓN DEL EXTRACTO
  // ==========================================

  pdf.setFillColor(245, 246, 248);

  pdf.roundedRect(
    margen,
    30,
    anchoPagina - margen * 2,
    34,
    2,
    2,
    'F'
  );

  pdf.setTextColor(55, 65, 81);
  pdf.setFontSize(8.5);

  const xEtiquetaIzquierda = margen + 5;
  const xDatoIzquierda = margen + 30;

  const xEtiquetaDerecha = 112;
  const xDatoDerecha = 151;

  // Columna izquierda
  pdf.setFont('helvetica', 'bold');
  pdf.text('PLACA:', xEtiquetaIzquierda, 44);
  pdf.text('CONTRATANTE:', xEtiquetaIzquierda, 52);
  pdf.text('ID FUEC:', xEtiquetaIzquierda, 60);

  pdf.setFont('helvetica', 'normal');
  pdf.text(dato(extracto?.placa), xDatoIzquierda, 44);
  pdf.text(dato(extracto?.nitc), xDatoIzquierda, 52);
  pdf.text(dato(extracto?.idfuec), xDatoIzquierda, 60);

  // Columna derecha
  pdf.setFont('helvetica', 'bold');
  pdf.text('ORIGEN - DESTINO:', xEtiquetaDerecha, 44);
  pdf.text('IMPRESIÓN:', xEtiquetaDerecha, 52);
  pdf.text('TOTAL ACTIVOS:', xEtiquetaDerecha, 60);

  pdf.setFont('helvetica', 'normal');

  // Limitar textos largos para evitar que se superpongan
  const anchoDatoDerecha = anchoPagina - margen - xDatoDerecha;

  pdf.text(
    pdf.splitTextToSize(ruta, anchoDatoDerecha)[0],
    xDatoDerecha,
    44
  );

  pdf.text(
    `${fecha} ${hora}`,
    xDatoDerecha,
    52
  );

  pdf.setFont('helvetica', 'bold');
  pdf.text(
    String(pasajerosActivos.length),
    xDatoDerecha,
    60
  );

  // ==========================================
  // 3. TABLA DE PASAJEROS ACTIVOS
  // ==========================================

  autoTable(pdf, {
    startY: 70,

    head: [[
      '#',
      'TIPO DOCUMENTO',
      'NÚMERO DOCUMENTO',
      'NOMBRE COMPLETO',
      
     
    ]],

    body: pasajerosActivos.map((pasajero, index) => [
      index + 1,
      dato(pasajero.tipo_documento),
      String(pasajero.numero_documento ?? ''),
      dato(pasajero.nombresCompleto),
     // pasajero.observacion?.trim() || 'SIN OBSERVACIÓN',
     
    ]),

    theme: 'grid',

    styles: {
      font: 'helvetica',
      fontSize: 8,
      cellPadding: 3,
      overflow: 'linebreak',
      textColor: [55, 65, 81],
      lineColor: [220, 223, 228],
      lineWidth: 0.2,
      valign: 'middle'
    },

    headStyles: {
      fillColor: [82,82,82],
      textColor: [255, 255, 255],
      fontStyle: 'bold',
      halign: 'center',
      valign: 'middle',
      cellPadding: 3
    },

    alternateRowStyles: {
      fillColor: [242,242,242]
    },

    columnStyles: {
      0: {
        cellWidth: 9,
        halign: 'center'
      },
      1: {
        cellWidth: 25
      },
      2: {
        cellWidth: 35
      },
      3: {
        cellWidth: 113
      },
     
      4: {
        cellWidth: 19,
        halign: 'center'
      }
    },

    margin: {
      top: 15,
      right: margen,
      bottom: 18,
      left: margen
    },

    // Pie de página en cada página
    didDrawPage: () => {
      pdf.setDrawColor(210, 214, 220);
      pdf.setLineWidth(0.3);

      pdf.line(
        margen,
        altoPagina - 14,
        anchoPagina - margen,
        altoPagina - 14
      );

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor(100, 100, 100);

      pdf.text(
        'ADMIN SEAF | Listado de pasajeros activos',
        margen,
        altoPagina - 8
      );

      pdf.text(
        `Página ${pdf.getNumberOfPages()}`,
        anchoPagina - margen,
        altoPagina - 8,
        { align: 'right' }
      );
    }
  });

  // ==========================================
  // 4. DESCARGAR PDF
  // ==========================================

  const nombreArchivo =
    `Pasajeros_Extracto_${dato(extracto?.idfuec)}.pdf`;

  //pdf.save(nombreArchivo);

  console.log('PDF generado correctamente:', nombreArchivo);
}

gestionarPasajeros(extracto: any): void {
  //console.log('Gestionar pasajeros para extracto:', extracto);
  if (!extracto) {
    console.error('No se encontró el ID del extracto');
    return;
  }

  const modalRef = this.modalService.open(
    ListadoPasajerosComponent,
    {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
      scrollable: true
    }
  );

  // Enviar el ID del extracto al modal
  modalRef.componentInstance.extracto = extracto;
modalRef.componentInstance.pasajeros = [
  ...(this.pasajeros ?? [])
];
  modalRef.result
    .then((resultado) => {
      if (resultado?.actualizado) {
        console.log('Gestión de pasajeros finalizada');
        console.log('Resultado completo del modal:', resultado);
      console.log('Pasajeros recibidos:', resultado?.pasajeros);
      console.log('Actualizado:', resultado?.actualizado);

      if (resultado?.actualizado) {
        this.pasajeros = resultado.pasajeros ?? [];

        console.log(
          'Pasajeros almacenados en CrearExtractoComponent:',
          this.pasajeros
        );
      }
      }
    })
    .catch(() => {
      // El modal fue cerrado sin confirmar.
    });
}

 guardarPasajero(pasajero: ExtractoPasajero): void {

    // si no esta creando un extracto
    console.log('Guardando pasajero:', pasajero);


  }



}